// src/i18n/locales/bn.js

export default {
  countries: {
    'AF': 'আফগানিস্তান',
    'AL': 'আলবেনিয়া',
    'DZ': 'আলজেরিয়া',
    'AD': 'অ্যান্ডোরা',
    'AO': 'অ্যাঙ্গোলা',
    'AG': 'অ্যান্টিগুয়া ও বারবুডা',
    'AR': 'আর্জেন্টিনা',
    'AM': 'আর্মেনিয়া',
    'AU': 'অস্ট্রেলিয়া',
    'AT': 'অস্ট্রিয়া',
    'AZ': 'আজারবাইজান',
    'BS': 'বাহামা',
    'BH': 'বাহরাইন',
    'BD': 'বাংলাদেশ',
    'BB': 'বারবাডোস',
    'BY': 'বেলারুশ',
    'BE': 'বেলজিয়াম',
    'BZ': 'বেলিজ',
    'BJ': 'বেনিন',
    'BT': 'ভুটান',
    'BO': 'বলিভিয়া',
    'BA': 'বসনিয়া ও হার্জেগোভিনা',
    'BW': 'বোতসোয়ানা',
    'BR': 'ব্রাজিল',
    'BN': 'ব্রুনাই',
    'BG': 'বুলগেরিয়া',
    'BF': 'বুরকিনা ফাসো',
    'BI': 'বুরুন্ডি',
    'CV': 'কিপ ভার্দে',
    'KH': 'কম্বোডিয়া',
    'CM': 'ক্যামেরুন',
    'CA': 'কানাডা',
    'CF': 'মধ্য আফ্রিকান প্রজাতন্ত্র',
    'TD': 'চাদ',
    'CL': 'চিলি',
    'CN': 'চীন',
    'CO': 'কলম্বিয়া',
    'KM': 'কমোরোস',
    'CG': 'কঙ্গো',
    'CD': 'কঙ্গো, গণতান্ত্রিক প্রজাতন্ত্র',
    'CR': 'কোস্টারিকা',
    'CI': 'আইভরি কোস্ট',
    'HR': 'ক্রোয়েশিয়া',
    'CU': 'কিউবা',
    'CY': 'সাইপ্রাস',
    'CZ': 'চেকিয়া',
    'DK': 'ডেনমার্ক',
    'DJ': 'জিবুতি',
    'DM': 'ডোমিনিকা',
    'DO': 'ডোমিনিকান প্রজাতন্ত্র',
    'EC': 'ইকুয়েডর',
    'EG': 'মিশর',
    'SV': 'এল সালভাদর',
    'GQ': 'নিরক্ষীয় গিনি',
    'ER': 'ইরিত্রিয়া',
    'EE': 'এস্তোনিয়া',
    'ET': 'ইথিওপিয়া',
    'FJ': 'ফিজি',
    'FI': 'ফিনল্যান্ড',
    'FR': 'ফ্রান্স',
    'GA': 'গ্যাবন',
    'GM': 'গাম্বিয়া',
    'GE': 'জর্জিয়া',
    'DE': 'জার্মানি',
    'GH': 'ঘানা',
    'GR': 'গ্রিস',
    'GD': 'গ্রেনাডা',
    'GT': 'গুয়াতেমালা',
    'GN': 'গিনি',
    'GW': 'গিনি-বিসাউ',
    'GY': 'গিয়ানা',
    'HT': 'হাইতি',
    'HN': 'হন্ডুরাস',
    'HU': 'হাঙ্গেরি',
    'IS': 'আইসল্যান্ড',
    'IN': 'ভারত',
    'ID': 'ইন্দোনেশিয়া',
    'IR': 'ইরান',
    'IQ': 'ইরাক',
    'IE': 'আয়ারল্যান্ড',
    'IL': 'ইসরায়েল',
    'IT': 'ইতালি',
    'JM': 'জ্যামাইকা',
    'JP': 'জাপান',
    'JO': 'জর্ডান',
    'KZ': 'কাজাখস্তান',
    'KE': 'কেনিয়া',
    'KI': 'কিরিবাতি',
    'KP': 'উত্তর কোরিয়া',
    'KR': 'দক্ষিণ কোরিয়া',
    'KW': 'কুয়েত',
    'KG': 'কিরগিজস্তান',
    'LA': 'লাওস',
    'LV': 'লাটভিয়া',
    'LB': 'লেবানন',
    'LS': 'লেসোথো',
    'LR': 'লাইবেরিয়া',
    'LY': 'লিবিয়া',
    'LI': 'লিশটেনস্টাইন',
    'LT': 'লিথুয়ানিয়া',
    'LU': 'লুক্সেমবুর্গ',
    'MG': 'মাদাগাস্কার',
    'MW': 'মালাউই',
    'MY': 'মালয়েশিয়া',
    'MV': 'মালদ্বীপ',
    'ML': 'মালি',
    'MT': 'মাল্টা',
    'MH': 'মার্শাল দ্বীপপুঞ্জ',
    'MR': 'মৌরিতানিয়া',
    'MU': 'মরিশাস',
    'MX': 'মেক্সিকো',
    'FM': 'মাইক্রোনেশিয়া',
    'MD': 'মলদোভা',
    'MC': 'মোনাকো',
    'MN': 'মঙ্গোলিয়া',
    'ME': 'মন্টিনিগ্রো',
    'MA': 'মরক্কো',
    'MZ': 'মোজাম্বিক',
    'MM': 'মিয়ানমার',
    'NA': 'নামিবিয়া',
    'NR': 'নাউরু',
    'NP': 'নেপাল',
    'NL': 'নেদারল্যান্ডস',
    'NZ': 'নিউজিল্যান্ড',
    'NI': 'নিকারাগুয়া',
    'NE': 'নাইজার',
    'NG': 'নাইজেরিয়া',
    'MK': 'উত্তর মেসিডোনিয়া',
    'NO': 'নরওয়ে',
    'OM': 'ওমান',
    'PK': 'পাকিস্তান',
    'PW': 'পালাউ',
    'PS': 'ফিলিস্তিন রাষ্ট্র',
    'PA': 'পানামা',
    'PG': 'পাপুয়া নিউগিনি',
    'PY': 'প্যারাগুয়ে',
    'PE': 'পেরু',
    'PH': 'ফিলিপাইন',
    'PL': 'পোল্যান্ড',
    'PT': 'পর্তুগাল',
    'QA': 'কাতার',
    'RO': 'রোমানিয়া',
    'RU': 'রাশিয়া',
    'RW': 'রুয়ান্ডা',
    'KN': 'সেন্ট কিটস ও নেভিস',
    'LC': 'সেন্ট লুসিয়া',
    'VC': 'সেন্ট ভিনসেন্ট ও গ্রেনাডাইনস',
    'WS': 'সামোয়া',
    'SM': 'সান মারিনো',
    'ST': 'সাও টোমে ও প্রিন্সিপে',
    'SA': 'সৌদি আরব',
    'SN': 'সেনেগাল',
    'RS': 'সার্বিয়া',
    'SC': 'সেশেলস',
    'SL': 'সিয়েরা লিওন',
    'SG': 'সিঙ্গাপুর',
    'SK': 'স্লোভাকিয়া',
    'SI': 'স্লোভেনিয়া',
    'SB': 'সলোমন দ্বীপপুঞ্জ',
    'SO': 'সোমালিয়া',
    'ZA': 'দক্ষিণ আফ্রিকা',
    'SS': 'দক্ষিণ সুদান',
    'ES': 'স্পেন',
    'LK': 'শ্রীলঙ্কা',
    'SD': 'সুদান',
    'SR': 'সুরিনাম',
    'SZ': 'এসওয়াতিনি',
    'SE': 'সুইডেন',
    'CH': 'সুইজারল্যান্ড',
    'SY': 'সিরিয়া',
    'TJ': 'তাজিকিস্তান',
    'TZ': 'তাঞ্জানিয়া',
    'TH': 'থাইল্যান্ড',
    'TL': 'তিমুর-লেস্তে',
    'TG': 'টোগো',
    'TO': 'টোঙ্গা',
    'TT': 'ত্রিনিদাদ ও টোবাগো',
    'TN': 'তিউনিসিয়া',
    'TR': 'তুরস্ক',
    'TM': 'তুর্কমেনিস্তান',
    'TV': 'টুভালু',
    'UG': 'উগান্ডা',
    'UA': 'ইউক্রেন',
    'AE': 'সংযুক্ত আরব আমিরাত',
    'GB': 'যুক্তরাজ্য',
    'US': 'যুক্তরাষ্ট্র',
    'UY': 'উরুগুয়ে',
    'UZ': 'উজবেকিস্তান',
    'VU': 'ভানুয়াতু',
    'VA': 'ভ্যাটিকান সিটি',
    'VE': 'ভেনেজুয়েলা',
    'VN': 'ভিয়েতনাম',
    'YE': 'ইয়েমেন',
    'ZM': 'জাম্বিয়া',
    'ZW': 'জিম্বাবুয়ে'
  },
  verification: {
    verifying: 'আপনার ইমেল যাচাই করা হচ্ছে...',
    success: 'ইমেল সফলভাবে যাচাই করা হয়েছে!',
    failed: 'যাচাইকরণ ব্যর্থ হয়েছে',
    accountVerified: 'আপনার অ্যাকাউন্ট সফলভাবে যাচাই করা হয়েছে। আপনি এখন আপনার অ্যাকাউন্টে লগ ইন করতে পারেন।',
    invalidLink: 'যাচাইকরণের লিঙ্কটি অবৈধ বা মেয়াদোত্তীর্ণ হয়ে গেছে।',
    missingToken: 'যাচাইকরণ টোকেন অনুপস্থিত।',
    generalError: 'যাচাইকরণের সময় একটি ত্রুটি ঘটেছে। অনুগ্রহ করে পরে আবার চেষ্টা করুন।',
    proceedToLogin: 'লগ ইনে এগিয়ে যান',
    backToLogin: 'লগ ইনে ফিরে যান'
  },
  admin: {
    huduma: 'Genie AI',
    dashboard: 'ড্যাশবোর্ড',
    system: 'সিস্টেম',
    settings: 'সেটিংস',
    overview: 'সংক্ষিপ্ত বিবরণ',
    database: 'ডেটাবেস',
    logs: 'লগস',
    userManagement: 'ইউজার ম্যানেজমেন্ট',
    security: 'নিরাপত্তা',
    systemAdministration: 'সিস্টেম অ্যাডমিনিস্ট্রেশন',
    loading: 'লোড হচ্ছে...',
    close: 'ড্যাশবোর্ড বন্ধ করুন',
    edit: 'সম্পাদনা করুন',
    systemUptime: 'সিস্টেম আপটাইম',
    avgResponseTime: 'গড় প্রতিক্রিয়া সময়',
    errorRate: 'ত্রুটির হার',
    activeUsers: 'সক্রিয় ব্যবহারকারী',
    monthlyActiveUsers: 'মাসিক সক্রিয় ব্যবহারকারী (MAU)',
    fromLastMonth: 'গত মাস থেকে',
    today: 'আজ',
    tabs: {
      overview: 'সিস্টেমের স্বাস্থ্য',
      hierarchy: 'জ্ঞান অনুক্রম',
      documents: 'ডকুমেন্ট ম্যানেজমেন্ট',
      database: 'ডেটাবেস',
      logs: 'লগস',
      security: 'নিরাপত্তা',
      users: 'ব্যবহারকারী'
    },
    contentManagement: "কনটেন্ট ম্যানেজমেন্ট",
    knowledgeHierarchy: "জ্ঞান অনুক্রম",
    documentManagement: "ডকুমেন্ট ম্যানেজমেন্ট",
    noLogsFound: "আজকের জন্য কোনো লগ পাওয়া যায়নি",
    invalidLogsResponse: "অবৈধ লগস সারাংশ প্রতিক্রিয়া কাঠামো",
    logsSummaryError: "লগস সারাংশ লোড করতে ব্যর্থ হয়েছে",
    buttons: {
      save: "সেভ করুন",
      cancel: "বাতিল করুন",
      switch: "যাই হোক সুইচ করুন",
      discard: "বাতিল করুন (Discard)"
    },
    confirm: {
      defaultTitle: "নিশ্চিত করুন",
      defaultMessage: "আপনি কি নিশ্চিত?"
    },
    systemHealthStatus: 'সিস্টেমের স্বাস্থ্য পরিস্থিতি',
    runDiagnostics: 'ডায়াগনস্টিকস চালান',
    resourceUsage: 'রিসোর্স ব্যবহার',
    services: {
      apiServices: 'API পরিষেবা',
      database: 'ডেটাবেস',
      cache: 'ক্যাশ (Cache)',
      storage: 'স্টোরেজ',
      messageQueue: 'মেসেজ কিউ (Message Queue)',
      externalApi: 'বাহ্যিক API'
    },
    resources: {
      cpu: 'CPU ব্যবহার',
      memory: 'মেমরি ব্যবহার',
      storage: 'স্টোরেজ ব্যবহার',
      network: 'নেটওয়ার্ক ব্যান্ডউইথ'
    },
    databaseManagement: 'ডেটাবেস ম্যানেজমেন্ট',
    reindexDatabase: 'ডেটাবেস রি-ইনডেক্স করুন',
    lastReindex: 'সর্বশেষ রি-ইনডেক্স',
    databaseSize: 'ডেটাবেসের আকার',
    totalTables: 'মোট টেবিল',
    logManagement: 'লগ ম্যানেজমেন্ট',
    rolloverLogs: 'রোলওভার লগস',
    searchLogs: 'লগ অনুসন্ধান করুন',
    logTime: 'সময়',
    logLevel: 'স্তর (Level)',
    logService: 'পরিষেবা',
    logMessage: 'বার্তা',
    showingEntries: '{total} এন্ট্রির মধ্যে {start}-{end} দেখাচ্ছে',
    logLevels: {
      error: 'ERROR',
      warn: 'WARN',
      info: 'INFO',
      debug: 'DEBUG'
    },
    logMessages: {
      connectionTimeout: 'বাহ্যিক প্রদানকারীর সাথে সংযোগ টাইমআউট',
      lowDiskSpace: 'ডিস্ক স্পেস ১০% থ্রেশহোল্ডের নিচে',
      userRoleUpdated: 'admin@huduma.ai এর জন্য ব্যবহারকারীর ভূমিকা আপডেট করা হয়েছে'
    },
    userName: 'নাম',
    userEmail: 'ইমেল',
    userRole: 'ভূমিকা',
    userStatus: 'স্ট্যাটাস',
    userActions: 'অ্যাকশন',
    roleAdministrator: 'অ্যাডমিনিস্ট্রেটর',
    roleUser: 'ব্যবহারকারী',
    statusActive: 'সক্রিয়',
    dbActions: {
      reindex: 'রি-ইনডেক্স',
      backup: 'ব্যাকআপ',
      optimize: 'অপ্টিমাইজ করুন',
      reindexDesc: 'ডেটাবেস ইনডেক্স পুনর্নির্মাণ করুন',
      backupDesc: 'ডেটাবেস ব্যাকআপ তৈরি করুন',
      optimizeDesc: 'কোয়েরি পারফরম্যান্স অপ্টিমাইজ করুন'
    },
    operations: {
      reindexTitle: 'ডেটাবেস রি-ইনডেক্স ফলাফল',
      backupTitle: 'ডেটাবেস ব্যাকআপ ফলাফল',
      optimizeTitle: 'ডেটাবেস অপ্টিমাইজেশন ফলাফল',
      reindexResults: 'রি-ইনডেক্স ফলাফল',
      optimizeResults: 'অপ্টিমাইজেশন ফলাফল',
      collection: 'সংগ্রহ (Collection)',
      status: 'স্ট্যাটাস',
      indexSuggestions: 'ইনডেক্স পরামর্শ',
      backupDetails: 'ব্যাকআপের বিবরণ',
      backupFile: 'ব্যাকআপ ফাইল',
      backupLocation: 'অবস্থান',
      backupSize: 'আকার',
      errorDetails: 'ত্রুটির বিবরণ',
      close: 'বন্ধ করুন',
      resultsTitle: 'অপারেশনের ফলাফল',
      reindexDatabase: {
        success: 'ডেটাবেস রি-ইনডেক্স সফলভাবে সম্পন্ন হয়েছে',
        error: 'ডেটাবেস রি-ইনডেক্স করার সময় ত্রুটি',
        loading: 'ডেটাবেস রি-ইনডেক্স করা হচ্ছে...'
      },
      backupDatabase: {
        success: 'ডেটাবেস ব্যাকআপ সফলভাবে সম্পন্ন হয়েছে',
        error: 'ডেটাবেস ব্যাকআপ করার সময় ত্রুটি',
        loading: 'ডেটাবেস ব্যাকআপ করা হচ্ছে...'
      },
      optimizeDatabase: {
        success: 'ডেটাবেস অপ্টিমাইজেশন সফলভাবে সম্পন্ন হয়েছে',
        error: 'ডেটাবেস অপ্টিমাইজ করার সময় ত্রুটি',
        loading: 'ডেটাবেস অপ্টিমাইজ করা হচ্ছে...'
      },
      rolloverLogs: {
        success: 'লগ রোলওভার সফলভাবে সম্পন্ন হয়েছে',
        loading: 'লগ রোলওভার করা হচ্ছে...'
      },
      searchLogs: {
        success: 'লগ অনুসন্ধান সম্পন্ন হয়েছে',
        loading: 'লগ অনুসন্ধান করা হচ্ছে...'
      },
      runDiagnostics: {
        success: 'ডায়াগনস্টিকস সফলভাবে সম্পন্ন হয়েছে',
        loading: 'ডায়াগনস্টিকস চালানো হচ্ছে...'
      },
      runSecurityScan: {
        success: 'সিকিউরিটি স্ক্যান সফলভাবে সম্পন্ন হয়েছে',
        loading: 'সিকিউরিটি স্ক্যান চালানো হচ্ছে...'
      },
      cancel: 'বাতিল করুন',
      save: 'পরিবর্তনগুলো সেভ করুন'
    },
    userManagementSection: {
      totalUsers: 'মোট ব্যবহারকারী',
      newUsers: 'নতুন ব্যবহারকারী (মাসিক)',
      searchUsers: 'ব্যবহারকারী খুঁজুন...',
      clearSearch: 'অনুসন্ধান মুছুন',
      search: 'অনুসন্ধান',
      usersFound: 'ব্যবহারকারী পাওয়া গেছে',
      showAllUsers: 'সকল ব্যবহারকারী দেখান',
      searching: 'খোঁজা হচ্ছে...',
      searchingUsers: 'ব্যবহারকারীদের খোঁজা হচ্ছে...',
      noUsersFound: 'আপনার অনুসন্ধানের মানদণ্ডের সাথে মেলে এমন কোনো ব্যবহারকারী পাওয়া যায়নি।',
      noUsers: 'কোনো ব্যবহারকারী উপলব্ধ নেই।',
      showing: 'দেখাচ্ছে',
      of: 'এর মধ্যে',
      previous: 'পূর্ববর্তী',
      next: 'পরবর্তী',
      searchFields: {
        all: 'সকল ফিল্ড',
        name: 'নাম',
        email: 'ইমেল',
        role: 'ভূমিকা'
      },
      userSearch: {
        resultsFound: '"{term}" এর সাথে মেলে এমন {total} জন ব্যবহারকারী পাওয়া গেছে',
        error: 'ব্যবহারকারী অনুসন্ধানে ত্রুটি'
      }
    },
    logsSection: {
      errorLogs: 'এরর লগস (Error Logs)',
      warningLogs: 'ওয়ার্নিং লগস (Warning Logs)',
      noErrorLogs: 'আজ কোনো এরর লগ রেকর্ড করা হয়নি।',
      noWarningLogs: 'আজ কোনো ওয়ার্নিং লগ রেকর্ড করা হয়নি।',
      infoLogsNote: 'ইনফো লগগুলি সারাংশে দেখানো হয় না। সমস্ত লগ প্রকার দেখতে অনুসন্ধান ফাংশন ব্যবহার করুন।',
      searchResults: 'সর্বশেষ অনুসন্ধান ফলাফল',
      entriesFound: 'এন্ট্রি পাওয়া গেছে',
      viewAllResults: 'সমস্ত ফলাফল দেখুন',
      logType: 'প্রকার',
      logCount: 'গণনা',
      logTypes: {
        connectionTimeout: 'সংযোগ টাইমআউট',
        databaseFailed: 'ডেটাবেস কোয়েরি ব্যর্থ হয়েছে',
        authFailed: 'প্রমাণীকরণ ব্যর্থতা',
        lowDiskSpace: 'ডিস্ক স্পেস থ্রেশহোল্ডের নিচে',
        slowQuery: 'ধীর কোয়েরি পারফরম্যান্স',
        rateLimit: 'রেট লিমিট কাছাকাছি'
      },
      logSearch: {
        noResultsFound: 'আপনার অনুসন্ধানের মানদণ্ডের সাথে কোনো লগ মেলেনি',
        resultsFound: '{count} টি লগ এন্ট্রি পাওয়া গেছে'
      }
    },
    security: {
      title: 'নিরাপত্তা মনিটরিং',
      securityScan: 'সিকিউরিটি স্ক্যান',
      runningSecurityScan: 'স্ক্যান চলছে...',
      lastSecurityScan: 'সর্বশেষ সিকিউরিটি স্ক্যান',
      vulnerabilitiesFound: 'দুর্বলতা পাওয়া গেছে',
      daysAgo: 'দিন আগে',
      critical: 'গুরুতর (Critical)',
      medium: 'মাঝারি (Medium)',
      low: 'নিম্ন (Low)',
      failedLoginAttempts: 'ব্যর্থ লগইন প্রচেষ্টা (২৪ ঘণ্টা)',
      suspiciousActivities: 'সন্দেহজনক কার্যকলাপ (২৪ ঘণ্টা)',
      securityRecommendations: 'নিরাপত্তা সুপারিশ',
      criticalVulnerabilities: 'গুরুতর দুর্বলতা',
      mediumVulnerabilities: 'মাঝারি দুর্বলতা',
      lowVulnerabilities: 'নিম্ন দুর্বলতা',
      authenticationIssues: 'প্রমাণীকরণ সমস্যা',
      suspiciousActivityLogs: 'সন্দেহজনক কার্যকলাপের লগ',
      securityProbeAttempts: 'নিরাপত্তা প্রোব প্রচেষ্টা সনাক্ত করা হয়েছে',
      sensitiveFileAccess: 'সংবেদনশীল ফাইল বা এন্ডপয়েন্ট অ্যাক্সেস করার প্রচেষ্টা সনাক্ত করা হয়েছে',
      envFileAccess: 'পরিবেশ ফাইল (.env) অ্যাক্সেসের প্রচেষ্টা',
      envFileAccessDesc: '.env ফাইল অ্যাক্সেস করার প্রচেষ্টা সনাক্ত করা হয়েছে',
      gitRepoAccess: 'গিট রিপোজিটরি অ্যাক্সেস প্রচেষ্টা',
      gitRepoAccessDesc: 'গিট রিপোজিটরি ফাইল অ্যাক্সেস করার প্রচেষ্টা সনাক্ত করা হয়েছে',
      recommendedAction: 'প্রস্তাবিত পদক্ষেপ',
      rateLimitRecommendation: 'রেট লিমিটিং বাস্তবায়ন, ক্রমাগত অপরাধীদের জন্য আইপি ব্লকিং এবং সার্ভার হার্ডেনিং ঠিকঠাক আছে কিনা তা নিশ্চিত করার কথা বিবেচনা করুন।',
      envFileRecommendation: 'নিশ্চিত করুন যে এনভায়রনমেন্ট ফাইলগুলি ওয়েব ডিরেক্টরি থেকে অ্যাক্সেসযোগ্য নয় এবং সার্ভার কনফিগারেশনগুলি সঠিকভাবে সংবেদনশীল ফাইলগুলিতে অ্যাক্সেস ব্লক করে।',
      gitRepoRecommendation: 'নিশ্চিত করুন যে .git ডিরেক্টরিগুলি সঠিকভাবে সুরক্ষিত এবং ওয়েব থেকে অ্যাক্সেসযোগ্য নয়।',
      noVulnerabilitiesFound: 'কোন দুর্বলতা পাওয়া যায়নি',
      systemSecure: 'আপনার সিস্টেম নিরাপদ বলে মনে হচ্ছে। নিয়মিত মনিটরিং চালিয়ে যান।',
      loadingScan: 'স্ক্যান ফলাফল লোড হচ্ছে...',
      occurrences: 'ঘটনাসমূহ',
      firstSeen: 'প্রথম দেখা গেছে',
      lastSeen: 'সর্বশেষ দেখা গেছে',
      timestamp: 'টাইমস্ট্যাম্প',
      message: 'বার্তা',
      service: 'পরিষেবা',
      type: 'প্রকার',
      severity: 'তীব্রতা',
      url: 'URL',
      matchedTerm: 'মিলে যাওয়া শব্দ',
      lineNumber: 'লাইন নম্বর',
      lineNumbers: 'লাইন নম্বরসমূহ',
      showLess: 'কম দেখান',
      showMore: 'সব সমস্যা দেখান',
      lastScanJustNow: "এইমাত্র"
    },
    userEdit: {
      title: 'ব্যবহারকারী সম্পাদনা করুন',
      loading: 'ব্যবহারকারীর ডেটা লোড হচ্ছে...',
      userInfo: 'ব্যবহারকারীর তথ্য',
      userId: 'ইউজার আইডি',
      loginName: 'লগইন নাম',
      fullName: 'পুরো নাম',
      dob: 'জন্ম তারিখ',
      email: 'ইমেল',
      emailVerified: 'ইমেল যাচাই করা হয়েছে',
      verified: 'যাচাইকৃত',
      notVerified: 'যাচাই করা হয়নি',
      createdAt: 'তৈরি করা হয়েছে',
      lastLogin: 'সর্বশেষ লগইন',
      never: 'কখনো না',
      accountSettings: 'অ্যাকাউন্ট সেটিংস',
      accountStatus: 'অ্যাকাউন্টের স্ট্যাটাস',
      accountEnabled: 'অ্যাকাউন্ট সক্রিয়',
      cannotDisableSelf: 'আপনি নিজের অ্যাকাউন্ট নিষ্ক্রিয় করতে পারবেন না',
      accountRole: 'অ্যাকাউন্টের ভূমিকা',
      adminRole: 'অ্যাডমিন ভূমিকা',
      cannotChangeOwnRole: 'আপনি নিজের ভূমিকা পরিবর্তন করতে পারবেন না',
      adminActions: 'অ্যাডমিন অ্যাকশন',
      verifyEmail: 'ইমেল যাচাই করুন',
      resetPassword: 'পাসওয়ার্ড রিসেট পাঠান',
      forceLogout: 'ফোর্স লগআউট',
      failedToLoad: 'ব্যবহারকারীর ডেটা লোড করতে ব্যর্থ',
      errorLoading: 'ব্যবহারকারীর ডেটা লোড করার সময় ত্রুটি',
      saveSuccess: 'ব্যবহারকারীর সেটিংস সফলভাবে আপডেট করা হয়েছে',
      errorSaving: 'ব্যবহারকারীর সেটিংস সেভ করার সময় ত্রুটি',
      verifyEmailSuccess: 'যাচাইকরণ ইমেল সফলভাবে পাঠানো হয়েছে',
      emailVerificationFailed: 'যাচাইকরণ ইমেল পাঠাতে ব্যর্থ',
      errorVerifyingEmail: 'যাচাইকরণ ইমেল পাঠানোর সময় ত্রুটি',
      passwordResetSent: 'পাসওয়ার্ড রিসেট ইমেল পাঠানো হয়েছে',
      passwordResetFailed: 'পাসওয়ার্ড রিসেট পাঠাতে ব্যর্থ',
      errorSendingReset: 'পাসওয়ার্ড রিসেট পাঠানোর সময় ত্রুটি',
      logoutForced: 'ব্যবহারকারীকে লগ আউট করা হয়েছে',
      logoutFailed: 'ফোর্স লগআউট করতে ব্যর্থ',
      errorForcingLogout: 'ফোর্স লগআউট করার সময় ত্রুটি',
      userUpdated: "ব্যবহারকারী সফলভাবে আপডেট করা হয়েছে"
    },
    hierarchy: {
      title: "জ্ঞান অনুক্রম পরিচালনা (নোট: সর্বদা ইংরেজি - অনুবাদ যোগ করুন)",
      addCategory: "নতুন বিভাগ যোগ করুন",
      loading: "অনুক্রম লোড হচ্ছে...",
      addService: "পরিষেবা যোগ করুন",
      editCategory: "বিভাগ সম্পাদনা করুন",
      deleteCategory: "বিভাগ মুছুন",
      editService: "পরিষেবা সম্পাদনা করুন",
      deleteService: "পরিষেবা মুছুন",
      empty: 'কোনো বিভাগ পাওয়া যায়নি। শুরু করতে "নতুন বিভাগ যোগ করুন" এ ক্লিক করুন।',
      formTitleCreateCategory: "নতুন বিভাগ তৈরি করুন",
      formTitleAddService: "\"{categoryName}\" এ পরিষেবা যোগ করুন",
      formTitleEditCategory: "বিভাগ সম্পাদনা করুন: \"{itemName}\"",
      formTitleEditService: "পরিষেবা সম্পাদনা করুন: \"{itemName}\"",
      nameEnLabel: "নাম (ইংরেজি)",
      translationsTitle: "প্রদর্শনের জন্য অনুবাদ",
      loadingTranslations: "অনুবাদ লোড হচ্ছে...",
      selectLang: "ভাষা নির্বাচন করুন",
      translationPlaceholder: "অনুবাদ লিখুন",
      deleteTranslation: "অনুবাদ মুছুন",
      addTranslation: "+ অনুবাদ যোগ করুন",
      saveSuccess: "অনুক্রম আইটেম সফলভাবে সংরক্ষিত হয়েছে।",
      saveError: "অনুক্রম আইটেম সংরক্ষণ করতে ব্যর্থ হয়েছে।",
      loadError: "জ্ঞান অনুক্রম লোড করতে ব্যর্থ হয়েছে।",
      loadTranslationsError: "অনুবাদ লোড করতে ব্যর্থ হয়েছে।",
      confirmCancelTitle: "অসংরক্ষিত পরিবর্তন",
      confirmCancelEdit: "আপনার কিছু অসংরক্ষিত পরিবর্তন আছে। আপনি কি নিশ্চিত যে আপনি বাতিল করতে চান?",
      confirmDeleteTitleCategory: "বিভাগ মুছবেন?",
      confirmDeleteTitleService: "পরিষেবা মুছবেন?",
      confirmDeleteCategory: "আপনি কি নিশ্চিত যে আপনি \"{itemName}\" বিভাগটি মুছতে চান? এই কাজটি আর ফেরানো যাবে না।",
      confirmDeleteService: "আপনি কি নিশ্চিত যে আপনি \"{itemName}\" পরিষেবাটি মুছতে চান? এই কাজটি আর ফেরানো যাবে না।",
      deleteSuccessCategory: "বিভাগ সফলভাবে মুছে ফেলা হয়েছে।",
      deleteSuccessService: "পরিষেবা সফলভাবে মুছে ফেলা হয়েছে।",
      deleteErrorCategory: "বিভাগ মুছতে ব্যর্থ হয়েছে।",
      deleteErrorService: "পরিষেবা মুছতে ব্যর্থ হয়েছে।",
      duplicateLangError: "অনুবাদে ডুপ্লিকেট ভাষা পাওয়া গেছে। অনুগ্রহ করে সেগুলি সরিয়ে দিন।"
    },
    documents: {
      title: "ডকুমেন্ট ম্যানেজমেন্ট",
      addLink: "লিঙ্ক থেকে যোগ করুন",
      uploadFiles: "ফাইল আপলোড করুন",
      searchPlaceholder: "ফাইলের নাম দিয়ে খুঁজুন...",
      allStatuses: "সব স্ট্যাটাস",
      statusPending: "পেন্ডিং",
      statusIngested: "ইনজেস্ট করা হয়েছে",
      statusRetracted: "প্রত্যাহার করা হয়েছে",
      statusIngesting: "ইনজেস্ট করা হচ্ছে",
      statusError: "ইনজেশন ত্রুটি",
      statusWarning: "সতর্কতাসহ ইনজেস্ট করা হয়েছে",
      ingestSelected: "নির্বাচিতগুলো ইনজেস্ট করুন",
      colFileName: "ফাইলের নাম",
      colStatus: "স্ট্যাটাস",
      colLabels: "লেবেল",
      colUploadDate: "আপলোডের তারিখ",
      colSize: "আকার",
      loading: "ডকুমেন্ট লোড হচ্ছে...",
      empty: "কোনো ডকুমেন্ট পাওয়া যায়নি।",
      loadError: "ডকুমেন্ট লোড করতে ব্যর্থ হয়েছে।",
      confirmIngestTitle: "ব্যাচ ইনজেশন নিশ্চিত করুন",
      ingest: "ইনজেস্ট করুন",
      confirmIngestSelected: "আপনি কি নিশ্চিত যে আপনি {count} টি নির্বাচিত ফাইল ইনজেস্ট করতে চান?",
      ingestQueuedSuccess: "{count} টি ফাইল ইনজেশনের জন্য সারিবদ্ধ করা হয়েছে।",
      ingestQueuedError: "ব্যাচ ইনজেশন প্রক্রিয়া চলাকালীন একটি ত্রুটি ঘটেছে।",
      uploadSuccessMultiple: "{count} টি ফাইল সফলভাবে আপলোড হয়েছে।",
      linkSubmitSuccess: "\"{fileName}\" সফলভাবে ক্রল এবং সেভ করা হয়েছে।",
      actionSuccess: "{fileId} ফাইলের উপর \"{action}\" অ্যাকশন সফল হয়েছে।",
      metadataUpdateSuccess: "{fileId} ফাইলের মেটাডেটা আপডেট করা হয়েছে।"
    }
  },
  passwordResetConfirm: {
    appTitle: 'Genie AI',
    resetPassword: 'নতুন পাসওয়ার্ড তৈরি করুন',
    tokenLabel: 'রিসেট টোকেন',
    tokenPlaceholder: 'রিসেট টোকেন লিখুন',
    validateButton: 'টোকেন যাচাই করুন',
    newPasswordLabel: 'নতুন পাসওয়ার্ড',
    newPasswordPlaceholder: 'একটি নতুন পাসওয়ার্ড তৈরি করুন',
    confirmNewPasswordLabel: 'নতুন পাসওয়ার্ড নিশ্চিত করুন',
    confirmNewPasswordPlaceholder: 'আপনার নতুন পাসওয়ার্ড নিশ্চিত করুন',
    resetButton: 'পাসওয়ার্ড রিসেট করুন',
    processing: 'প্রক্রিয়াকরণ হচ্ছে...',
    rememberedPassword: 'পাসওয়ার্ড মনে পড়েছে?',
    backToLogin: 'লগ ইনে ফিরে যান',
    supportMessage: 'সাহায্য প্রয়োজন? আমাদের সাপোর্ট টিমের সাথে যোগাযোগ করুন',
    passwordRequirements: 'পাসওয়ার্ডে অন্তত ৮টি অক্ষর থাকতে হবে যার মধ্যে অন্তত ১টি সংখ্যা, ১টি বড় হাতের অক্ষর এবং ১টি বিশেষ অক্ষর থাকতে হবে',
    passwordsDoNotMatch: 'পাসওয়ার্ড মিলছে না',
    resetSuccess: 'আপনার পাসওয়ার্ড সফলভাবে রিসেট করা হয়েছে',
    resetFailed: 'পাসওয়ার্ড রিসেট করতে অক্ষম। অনুগ্রহ করে আবার চেষ্টা করুন।',
    noTokenProvided: 'অনুগ্রহ করে একটি রিসেট টোকেন প্রদান করুন',
    expiredToken: 'এই রিসেট টোকেনের মেয়াদ শেষ হয়ে গেছে। অনুগ্রহ করে একটি নতুন অনুরোধ করুন।',
    invalidToken: 'অবৈধ বা অচেনা রিসেট টোকেন',
    validatingToken: 'টোকেন যাচাই করা হচ্ছে...',
    redirecting: 'লগইন পৃষ্ঠায় রিডাইরেক্ট করা হচ্ছে...',
    passwordStrength: 'পাসওয়ার্ডের শক্তি',
    strengthLabels: {
      veryWeak: 'খুব দুর্বল',
      weak: 'দুর্বল',
      fair: 'মোটামুটি',
      good: 'ভালো',
      strong: 'শক্তিশালী'
    },
    passwordSuggestions: {
      atLeast8Chars: 'অন্তত ৮টি অক্ষর ব্যবহার করুন',
      addUppercase: 'বড় হাতের অক্ষর যোগ করুন',
      addLowercase: 'ছোট হাতের অক্ষর যোগ করুন',
      addNumbers: 'সংখ্যা যোগ করুন',
      addSpecialChars: 'বিশেষ অক্ষর যোগ করুন'
    }
  },
  passwordReset: {
    appTitle: 'Genie AI',
    resetPassword: 'আপনার পাসওয়ার্ড রিসেট করুন',
    emailLabel: 'ইমেল ঠিকানা',
    emailPlaceholder: 'আপনার ইমেল লিখুন',
    resetButton: 'রিসেট লিঙ্ক পাঠান',
    processing: 'পাঠানো হচ্ছে...',
    rememberPassword: 'পাসওয়ার্ড মনে পড়েছে?',
    backToLogin: 'লগ ইনে ফিরে যান',
    supportMessage: 'সাহায্য প্রয়োজন? আমাদের সাপোর্ট টিমের সাথে যোগাযোগ করুন',
    invalidEmail: 'অনুগ্রহ করে একটি বৈধ ইমেল ঠিকানা লিখুন',
    resetRequestSuccess: 'পাসওয়ার্ড রিসেট লিঙ্ক আপনার ইমেলে পাঠানো হয়েছে',
    resetRequestFailed: 'পাসওয়ার্ড রিসেট লিঙ্ক পাঠাতে অক্ষম। অনুগ্রহ করে আবার চেষ্টা করুন।',
    checkEmail: 'অনুগ্রহ করে পরবর্তী নির্দেশাবলীর জন্য আপনার ইমেল চেক করুন।'
  },
  register: {
    appTitle: "Genie AI",
    createAccount: "নতুন অ্যাকাউন্ট তৈরি করুন",
    username: "ইউজারনেম",
    usernamePlaceholder: "একটি ইউজারনেম লিখুন",
    email: "ইমেল",
    emailPlaceholder: "আপনার ইমেল লিখুন",
    password: "পাসওয়ার্ড",
    passwordPlaceholder: "একটি পাসওয়ার্ড তৈরি করুন",
    confirmPassword: "পাসওয়ার্ড নিশ্চিত করুন",
    confirmPasswordPlaceholder: "আপনার পাসওয়ার্ড নিশ্চিত করুন",
    acceptTerms: "আমি সম্মত হচ্ছি",
    termsOfService: "পরিষেবার শর্তাবলীতে",
    registerButton: "অ্যাকাউন্ট তৈরি করুন",
    processing: "প্রক্রিয়াকরণ হচ্ছে...",
    alreadyHaveAccount: "ইতিমধ্যে একটি অ্যাকাউন্ট আছে?",
    loginNow: "লগ ইন করুন",
    privacyNotice: "নিবন্ধন করার মাধ্যমে, আপনি আমাদের পরিষেবার শর্তাবলী এবং গোপনীয়তা নীতির সাথে সম্মত হচ্ছেন",
    usernameMinLength: "ইউজারনেম অন্তত ৩টি অক্ষরের হতে হবে",
    invalidEmail: "অনুগ্রহ করে একটি বৈধ ইমেল ঠিকানা লিখুন",
    passwordRequirements: "পাসওয়ার্ডে অন্তত ৮টি অক্ষর, ১টি সংখ্যা এবং ১টি বড় হাতের অক্ষর থাকতে হবে",
    passwordsDoNotMatch: "পাসওয়ার্ড মিলছে না",
    mustAcceptTerms: "আপনাকে অবশ্যই পরিষেবার শর্তাবলী গ্রহণ করতে হবে",
    registrationFailed: "নিবন্ধন ব্যর্থ হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।",
    usernameExists: "ইউজারনেম ইতিমধ্যে বিদ্যমান",
    emailExists: "ইমেল ইতিমধ্যে বিদ্যমান",
    registrationSuccess: "নিবন্ধন সফল হয়েছে!",
    verificationEmailSent: "{email}-এ একটি যাচাইকরণ ইমেল পাঠানো হয়েছে",
    checkEmailInstructions: "অনুগ্রহ করে আপনার ইমেল চেক করুন এবং লগ ইন করার আগে আপনার অ্যাকাউন্ট যাচাই করার নির্দেশাবলী অনুসরণ করুন।",
    backToLogin: "লগ ইনে ফিরে যান",
    noEmailReceived: "কোনো ইমেল পাননি?",
    resendVerification: "যাচাইকরণ ইমেল পুনরায় পাঠান",
    verificationResent: "যাচাইকরণ ইমেল পুনরায় পাঠানো হয়েছে",
    verificationResendFailed: "যাচাইকরণ ইমেল পুনরায় পাঠাতে ব্যর্থ হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।",
    usernameInvalidChars: 'ইউজারনেমে শুধুমাত্র অক্ষর, সংখ্যা, আন্ডারস্কোর, ডট এবং হাইফেন থাকতে পারে',
    networkError: 'নেটওয়ার্ক ত্রুটি। অনুগ্রহ করে আপনার সংযোগ পরীক্ষা করুন এবং আবার চেষ্টা করুন।'
  },
  login: {
    appTitle: 'Genie AI',
    username: 'ইউজারনেম',
    password: 'পাসওয়ার্ড',
    loginButton: 'লগইন',
    or: 'অথবা',
    savedAccounts: 'সংরক্ষিত অ্যাকাউন্ট',
    loginSuccess: 'লগইন সফল হয়েছে',
    loginError: 'লগইন ব্যর্থ হয়েছে। অনুগ্রহ করে আপনার তথ্য চেক করুন।',
    googleLogin: 'Google-এর সাথে চালিয়ে যান',
    facebookLogin: 'Facebook-এর সাথে চালিয়ে যান',
    rememberMe: 'আমাকে মনে রাখুন',
    forgotPassword: 'পাসওয়ার্ড ভুলে গেছেন?',
    noAccount: 'অ্যাকাউন্ট নেই?',
    createAccount: 'অ্যাকাউন্ট তৈরি করুন',
    registerNow: "এখনই নিবন্ধন করুন",
    termsAndPolicy: 'লগ ইন করার মাধ্যমে, আপনি আমাদের পরিষেবার শর্তাবলী এবং গোপনীয়তা নীতির সাথে সম্মত হচ্ছেন',
    loggingIn: "লগ ইন করা হচ্ছে...",
    fieldsRequired: "ইউজারনেম এবং পাসওয়ার্ড আবশ্যক",
    invalidCredentials: "অবৈধ ইউজারনেম বা পাসওয়ার্ড",
    tooManyAttempts: "অতিরিক্ত লগইন প্রচেষ্টা। অনুগ্রহ করে পরে আবার চেষ্টা করুন।",
    loginFailed: "লগইন ব্যর্থ হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।",
    oauthNotImplemented: "সোশ্যাল লগইন এখনও কার্যকর করা হয়নি",
    savedLoginNotImplemented: "সংরক্ষিত অ্যাকাউন্ট লগইন এখনও কার্যকর করা হয়নি"
  },
  charts: {
    tooltip: {
      title: 'তারিখ',
      totalQueries: 'মোট কোয়েরি',
      uniqueUsers: 'অনন্য ব্যবহারকারী'
    },
    day: 'দিন',
    noData: 'কোনো ডেটা নেই',
    notAvailable: 'প্রযোজ্য নয়',
    topQueries: 'শীর্ষ কোয়েরি',
    categoryDistribution: 'জ্ঞান এলাকার ব্যবহার',
    usageTrend: 'ব্যবহারের প্রবণতা'
  },
  analytics: {
    title: 'ডেটা অ্যানালিটিক্স এবং ইনসাইট',
    loading: 'অ্যানালিটিক্স ডেটা লোড হচ্ছে...',
    period: 'সময়কাল',
    charts: {
      satisfactionHeatmap: "জ্ঞান এলাকা অনুযায়ী সন্তুষ্টি",
      satisfactionSubtitle: "সময়ের সাথে সাথে শতাংশ স্কোর"
    },
    timePeriods: {
      week4: "৪ সপ্তাহ আগে",
      week3: "৩ সপ্তাহ আগে",
      week2: "২ সপ্তাহ আগে",
      week1: "গত সপ্তাহ",
      current: "বর্তমান"
    },
    errors: {
      loading: "সন্তুষ্টি ডেটা লোড করতে ব্যর্থ হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।",
    },
    status: {
      loading: 'লোড হচ্ছে...',
      noData: 'এই সময়কালের জন্য কোনো ডেটা উপলব্ধ নেই',
      error: 'অ্যানালিটিক্স ডেটা লোড করতে ব্যর্থ',
      online: "সিস্টেম অনলাইন",
      offline: "সিস্টেম অফলাইন",
      responseTime: "গড় প্রতিক্রিয়া সময়",
      queueLength: "সারিবদ্ধ (Queue)",
      uptime: "আপটাইম"
    },
    periods: {
      daily: 'দৈনিক',
      weekly: 'সাপ্তাহিক',
      monthly: 'মাসিক',
      allTime: 'সব সময়'
    },
    metrics: {
      totalQueries: 'মোট কোয়েরি',
      uniqueUsers: 'অনন্য ব্যবহারকারী',
      avgResponseTime: 'গড় প্রতিক্রিয়া সময়',
      satisfaction: 'ব্যবহারকারীর সন্তুষ্টি'
    },
    table: {
      rank: 'র‍্যাঙ্ক',
      query: 'কোয়েরি',
      count: 'গণনা',
      avgTime: 'গড় সময়'
    },
    chartLabels: {
      categories: 'এলাকা',
      serviceCategories: 'জ্ঞান এলাকা',
      byUsage: 'ব্যবহার অনুযায়ী',
      category: 'এলাকা'
    },
    tooltips: {
      selectPeriod: 'সময়কাল নির্বাচন করুন',
      selectDate: 'তারিখ নির্বাচন করুন',
      exportData: 'ডেটা এক্সপোর্ট করুন'
    },
    gauge: {
      historical: 'ঐতিহাসিক প্রবণতা',
      vsPrevious: 'আগের সময়কালের তুলনায়',
      target: 'লক্ষ্য'
    },
    ratings: {
      poor: "খারাপ",
      average: "গড়",
      good: "ভালো",
      excellent: "চমৎকার"
    },
    slower: 'ধীর',
    faster: 'দ্রুত',
    percentage: 'শতাংশ',
    note: 'নীচে ব্যবহারের পরিসংখ্যান এবং ব্যবহারকারীদের প্রতিক্রিয়ার সারাংশ দেওয়া হলো।',
    usageStats: 'ব্যবহারের পরিসংখ্যান',
    peakUsers: 'সর্বোচ্চ সমসাময়িক ব্যবহারকারী',
    activeChats: 'সক্রিয় চ্যাট',
    usageTrend: 'ব্যবহারের প্রবণতা',
    topQueries: 'শীর্ষ কোয়েরি',
    feedbackSamples: 'ব্যবহারকারীর প্রতিক্রিয়ার নমুনা',
    close: 'বন্ধ করুন',
    chartComingSoon: 'ইন্টারেক্টিভ চার্ট ভিজ্যুয়ালাইজেশন শীঘ্রই আসছে...',
    retry: 'পুনরায় চেষ্টা করুন',
    dailyQueries: 'দৈনিক কোয়েরি',
    export: 'ডেটা এক্সপোর্ট করুন',
    dateRange: 'তারিখের পরিসর',
    startDate: 'শুরুর তারিখ',
    endDate: 'শেষ তারিখ',
    rank: 'র‍্যাঙ্ক',
    query: 'কোয়েরি',
    count: 'গণনা',
    avgTime: 'গড় সময়',
    serviceUsage: 'জ্ঞান এলাকার ব্যবহার',
    usageTrends: 'ব্যবহারের প্রবণতা',
    week: 'গত সপ্তাহ',
    month: 'গত মাস',
    quarter: 'গত প্রান্তিক',
    year: 'গত বছর',
    uniqueUsers: 'অনন্য ব্যবহারকারী',
    satisfactionRate: 'সন্তুষ্টির হার',
    satisfactionAnalysis: 'ব্যবহারকারীর সন্তুষ্টি বিশ্লেষণ'
  },
  brandName: 'Genie AI: আপনার ডিজিটাল সরকারি সহকারী',
  nav: {
    systemStatus: 'সিস্টেম স্ট্যাটাস',
    menu: 'মেনু',
    analytics: 'অ্যানালিটিক্স',
    userProfile: 'ব্যবহারকারীর প্রোফাইল',
    settings: 'সেটিংস',
    logout: 'লগ আউট',
    profile: 'আমার প্রোফাইল',
    toggleSidebar: 'সাইডবার টগল করুন',
    changeLanguage: 'ভাষা পরিবর্তন করুন',
    administration: "অ্যাডমিনিস্ট্রেশন",
    languages: {
      english: 'ইংরেজি',
      french: 'ফরাসি',
      swahili: 'সোয়াহিলি'
    }
  },
  systemStatus: {
    title: 'পরিষেবা স্ট্যাটাস',
    services: 'পরিষেবা',
    operational: 'কার্যকর',
    degraded: 'অবনতি (Degraded)',
    outage: 'বিভ্রাট (Outage)',
    allOperational: 'সমস্ত সিস্টেম',
    someIssues: 'কিছু সমস্যা',
    majorIssues: 'বড় সমস্যা',
    checking: 'চেক করা হচ্ছে...',
    nextDeadline: 'পরবর্তী সময়সীমা',
    days: 'দিন',
    viewDetails: 'বিস্তারিত দেখুন'
  },
  services: {
    eCitizen: 'ই-সিটিজেন পোর্টাল',
    taxFiling: 'ট্যাক্স ফাইলিং সিস্টেম',
    idApplication: 'আইডি আবেদন',
    businessReg: 'ব্যবসা নিবন্ধন',
    drivingLicense: 'ড্রাইভিং লাইসেন্স'
  },
  deadlines: {
    taxFiling: 'ট্যাক্স ফাইলিং সময়সীমা',
    businessRenewal: 'বিজনেস লাইসেন্স নবায়ন',
    idRenewal: 'আইডি কার্ড নবায়ন',
    vehicleRegistration: 'গাড়ী নিবন্ধনের সময়সীমা'
  },
  sidebar: {
    governmentServices: 'জ্ঞান এলাকা',
    chatHistory: 'চ্যাটের ইতিহাস',
    searchPlaceholder: 'জ্ঞান এলাকা অনুসন্ধান করুন...',
    createFolder: 'ফোল্ডার তৈরি করুন',
    editFolder: 'ফোল্ডার সম্পাদনা করুন',
    folderName: 'ফোল্ডারের নাম',
    folderNamePlaceholder: 'ফোল্ডারের নাম লিখুন',
    moveChat: 'চ্যাট সরান',
    moveChatTo: 'চ্যাট এখানে সরান',
    selectFolder: 'ফোল্ডার নির্বাচন করুন',
    deleteChat: 'চ্যাট মুছুন',
    deleteChatConfirm: 'আপনি কি নিশ্চিত যে আপনি এই চ্যাটটি মুছতে চান?',
    deleteChatWarning: 'এই কাজটি আর ফেরানো যাবে না।',
    renameChat: "চ্যাটের নাম পরিবর্তন করুন",
    chatTitle: "চ্যাটের শিরোনাম",
    chatTitlePlaceholder: "এই চ্যাটের জন্য একটি শিরোনাম লিখুন",
    deleteFolder: "ফোল্ডার মুছুন",
    deleteFolderConfirm: "আপনি কি নিশ্চিত যে আপনি '{name}' ফোল্ডারটি মুছতে চান?",
    chatsMoveWarning: "এই ফোল্ডারের সমস্ত চ্যাট ডিফল্ট ফোল্ডারে সরানো হবে।",
    weatherError: "আবহাওয়ার ডেটা লোড করতে অক্ষম। অনুগ্রহ করে আবার চেষ্টা করুন।",
    weatherTitle: 'আবহাওয়ার পূর্বাভাস',
    weatherLoading: 'আবহাওয়ার ডেটা লোড হচ্ছে...',
    weatherLocationLoading: 'অবস্থান লোড হচ্ছে...',
    weatherErrorDefault: 'আবহাওয়ার ডেটা পুনরুদ্ধার করতে অক্ষম।',
    weatherGeolocationUnsupported: 'ভৌগোলিক অবস্থান আপনার ব্রাউজার দ্বারা সমর্থিত নয়।',
    weatherRefresh: 'আবহাওয়া রিফ্রেশ করুন',
    weatherConditions: {
      clear: 'পরিষ্কার',
      partlycloudy: 'আংশিক মেঘলা',
      cloudy: 'মেঘলা',
      overcast: 'মেঘাচ্ছন্ন',
      rain: 'বৃষ্টি',
      shower: 'শাওয়ার',
      thunderstorm: 'বজ্রঝড়',
      snow: 'তুষারপাত'
    },
    folders: "ফোল্ডার",
    emptyFolder: "এই ফোল্ডারটি খালি। চ্যাট মেনু থেকে এখানে কথোপকথন সরান।",
    title: 'তথ্য ও সম্পদ',
    noChats: 'কোনো সাম্প্রতিক চ্যাট নেই',
    relatedDocs: 'সম্পর্কিত ডকুমেন্ট',
    noDocuments: 'কোনো সম্পর্কিত ডকুমেন্ট নেই',
    faq: 'সচরাচর জিজ্ঞাস্য প্রশ্ন',
    tab: {
      all: 'সমস্ত চ্যাট',
      folders: 'ফোল্ডার',
      starred: 'তারকা চিহ্নিত',
      archived: 'আর্কাইভ করা'
    },
    savedChats: 'সংরক্ষিত চ্যাট',
    chats: "চ্যাট",
    allChats: "সমস্ত চ্যাট",
    noFolder: "কোনো ফোল্ডার নেই",
    starredChats: "তারকা চিহ্নিত চ্যাট",
    archivedChats: "আর্কাইভ করা চ্যাট",
    noStarredChats: "এখনো কোনো তারকা চিহ্নিত কথোপকথন নেই। কথোপকথন তারকা চিহ্নিত করে এখানে যোগ করুন।",
    noArchivedChats: "এখনো কোনো আর্কাইভ করা কথোপকথন নেই।",
    noSearchResults: '"{term}" এর জন্য কোনো কথোপকথন পাওয়া যায়নি',
    loadingChats: "কথোপকথন লোড হচ্ছে...",
    errorLoadingConversations: "কথোপকথন লোড করতে ব্যর্থ। অনুগ্রহ করে আবার চেষ্টা করুন।",
    errorLoadingUser: "ব্যবহারকারীর ডেটা অসম্পূর্ণ। অনুগ্রহ করে পৃষ্ঠাটি পুনরায় লোড করুন।",
    errorNoUser: "ব্যবহারকারীর ডেটা অনুপস্থিত। অনুগ্রহ করে পৃষ্ঠাটি পুনরায় লোড করুন।",
    retry: "পুনরায় চেষ্টা করুন",
    message: "বার্তা",
    messages: "বার্তা",
    created: "তৈরি করা হয়েছে",
    updated: "আপডেট করা হয়েছে",
    star: "তারকা চিহ্নিত করুন",
    unstar: "তারকাচিহ্ন সরান",
    archive: "আর্কাইভ করুন",
    chatStarred: "কথোপকথন তারকা চিহ্নিত করা হয়েছে",
    chatUnstarred: "কথোপকথন থেকে তারকাচিহ্ন সরানো হয়েছে",
    chatArchived: "কথোপকথন আর্কাইভ করা হয়েছে",
    chatUnarchived: "কথোপকথন আর্কাইভ থেকে সরানো হয়েছে",
    errorUpdatingChat: "কথোপকথন আপডেট করতে ব্যর্থ",
    chatRenamed: "কথোপকথনের নাম সফলভাবে পরিবর্তন করা হয়েছে",
    errorRenamingChat: "কথোপকথনের নাম পরিবর্তন করতে ব্যর্থ",
    chatDeleted: "কথোপকথন সফলভাবে মুছে ফেলা হয়েছে",
    errorDeletingChat: "কথোপকথন মুছতে ব্যর্থ",
    chatMoved: "কথোপকথন সফলভাবে সরানো হয়েছে",
    errorMovingChat: "কথোপকথন সরাতে ব্যর্থ",
    noPreview: "কোনো প্রিভিউ উপলব্ধ নেই",
    searchConversations: 'কথোপকথন অনুসন্ধান করুন...',
    selectFolderInstruction: "কথোপকথন দেখতে একটি ফোল্ডার নির্বাচন করুন",
    folderCreated: "ফোল্ডার সফলভাবে তৈরি করা হয়েছে",
    errorCreatingFolder: "ফোল্ডার তৈরি করতে ব্যর্থ",
    errorLoadingFolders: "ফোল্ডার লোড করতে ব্যর্থ",
    folderUpdated: "ফোল্ডার সফলভাবে আপডেট করা হয়েছে",
    errorUpdatingFolder: "ফোল্ডার আপডেট করতে ব্যর্থ",
    folderDeleted: "ফোল্ডার সফলভাবে মুছে ফেলা হয়েছে",
    errorDeletingFolder: "ফোল্ডার মুছতে ব্যর্থ",
    chatRemovedFromFolders: "ফোল্ডার থেকে কথোপকথন সরানো হয়েছে",
    errorRemovingChat: "ফোল্ডার থেকে কথোপকথন সরাতে ব্যর্থ",
    id: 'আইডি',
    labels: 'লেবেল',
    confidence: 'বিশ্বাসযোগ্যতা',
    unknown: 'অজানা'
  },
  leftPanel: {
    cat1: {
      name: '১. পরিচয় এবং নাগরিক নিবন্ধন',
      children: ['জন্ম নিবন্ধন', 'জাতীয় পরিচয়পত্র', 'পাসপোর্ট', 'বিবাহ এবং মৃত্যু সনদ', 'ভোটার নিবন্ধন']
    },
    cat2: {
      name: '২. স্বাস্থ্যসেবা এবং সামাজিক সেবা',
      children: ['পাবলিক স্বাস্থ্যসেবা অ্যাক্সেস', 'টিকাদান কর্মসূচি', 'স্বাস্থ্য বীমা', 'প্রতিবন্ধী সুবিধা', 'কল্যাণ এবং খাদ্য সহায়তা']
    },
    cat3: {
      name: '৩. শিক্ষা এবং শিখন',
      children: ['পাবলিক স্কুল এবং বিশ্ববিদ্যালয়', 'বৃত্তি এবং শিক্ষা ঋণ', 'বয়স্ক শিক্ষা কার্যক্রম', 'অনলাইন লার্নিং রিসোর্স']
    },
    cat4: {
      name: '৪. কর্মসংস্থান এবং শ্রম পরিষেবা',
      children: ['চাকরি অনুসন্ধান এবং বেকারত্ব সুবিধা', 'শ্রমিক সুরক্ষা এবং শ্রম অধিকার', 'কর্মক্ষেত্রে সুরক্ষা প্রবিধান', 'দক্ষতা প্রশিক্ষণ এবং শিক্ষানবিশ']
    },
    cat5: {
      name: '৫. কর এবং রাজস্ব',
      children: ['আয়কর রিটার্ন এবং রিফান্ড', 'সম্পত্তি কর প্রদান', 'ব্যবসা কর সম্মতি', 'কাস্টমস এবং আমদানি শুল্ক']
    },
    cat6: {
      name: '৬. জননিরাপত্তা এবং আইন বিচার',
      children: ['পুলিশ এবং জরুরি সেবা', 'আদালত এবং আইনি সহায়তা পরিষেবা', 'অপরাধ রিপোর্টিং', 'ভোক্তা সুরক্ষা আইন']
    },
    cat7: {
      name: '৭. পরিবহন এবং গতিশীলতা',
      children: ["ড্রাইভিং লাইসেন্স এবং যানবাহন নিবন্ধন", 'পাবলিক ট্রানজিট এবং অবকাঠামো', 'ট্রাফিক আইন লঙ্ঘন এবং জরিমানা', 'সড়ক নিরাপত্তা কর্মসূচি']
    },
    cat8: {
      name: '৮. আবাসন এবং নগর উন্নয়ন',
      children: ['পাবলিক আবাসন সহায়তা', 'সম্পত্তি নিবন্ধন এবং ভূমি রেকর্ড', 'আবাসন ঋণ এবং ভর্তুকি', 'জোনিং এবং বিল্ডিং পারমিট']
    },
    cat9: {
      name: '৯. ইউটিলিটি এবং পরিবেশ',
      children: ['জল এবং বিদ্যুৎ পরিষেবা', 'বর্জ্য ব্যবস্থাপনা এবং পুনর্ব্যবহার', 'পরিবেশগত নিয়মকানুন', 'নবায়নযোগ্য শক্তি উদ্যোগ']
    },
    cat10: {
      name: '১০. ব্যবসা এবং বাণিজ্য',
      children: ['ব্যবসা নিবন্ধন এবং লাইসেন্সিং', 'বাণিজ্য নিয়মকানুন এবং পারমিট', 'ছোট ব্যবসা অনুদান এবং প্রণোদনা', 'ই-কমার্স এবং ডিজিটাল ব্যবসা সমর্থন']
    },
    cat11: {
      name: '১১. সামাজিক নিরাপত্তা এবং পেনশন',
      children: ['অবসর সুবিধা', 'পেনশন তহবিল ব্যবস্থাপনা', 'সারভাইভার বেনিফিট', 'প্রতিবন্ধী পেনশন']
    },
    cat12: {
      name: '১২. সম্প্রদায় এবং নাগরিক সম্পৃক্ততা',
      children: ['ভোটদান এবং নির্বাচন', 'জনসাধারণের প্রতিক্রিয়া এবং নাগরিক অভিযোগ', 'স্বেচ্ছাসেবী এবং সম্প্রদায় কর্মসূচি', 'স্থানীয় সরকার অংশগ্রহণ']
    }
  },
  settings: {
    title: 'সেটিংস',
    save: 'সেভ করুন',
    close: 'বন্ধ করুন',
    saveSettings: 'সেটিংস সংরক্ষণ করুন',
    savingSettings: "আপনার সেটিংস সেভ করা হচ্ছে...",
    settingsSaved: "সেটিংস সফলভাবে সংরক্ষিত হয়েছে!",
    saveSuccess: 'সেটিংস সফলভাবে সংরক্ষিত হয়েছে',
    saveError: 'সেটিংস সেভ করতে ত্রুটি',
    display: 'ডিসপ্লে',
    displayLanguage: 'প্রদর্শনের ভাষা',
    languages: {
      english: 'ইংরেজি',
      french: 'ফরাসি',
      swahili: 'সোয়াহিলি'
    },
    theme: 'থিম',
    themes: {
      light: 'লাইট',
      dark: 'ডার্ক',
      system: 'সিস্টেম'
    },
    fontSize: 'ফন্টের আকার',
    notifications: 'বিজ্ঞপ্তি',
    emailUpdates: 'ইমেল আপডেট',
    soundNotifications: 'সাউন্ড বিজ্ঞপ্তি',
    accountManagement: 'অ্যাকাউন্ট ব্যবস্থাপনা',
    emailAddress: 'ইমেল ঠিকানা',
    emailAddressPlaceholder: 'আপনার ইমেল ঠিকানা',
    password: 'পাসওয়ার্ড',
    changePassword: 'পাসওয়ার্ড পরিবর্তন করুন',
    resetUserData: 'ব্যবহারকারীর ডেটা রিসেট করুন',
    resetUserDataDesc: 'এটি আপনার প্রোফাইলের সমস্ত ডেটা এবং চ্যাটের ইতিহাস মুছে ফেলবে।',
    deleteAccount: 'অ্যাকাউন্ট মুছুন',
    deleteAccountDesc: 'এটি স্থায়ীভাবে আপনার অ্যাকাউন্ট এবং এর সাথে যুক্ত সমস্ত ডেটা মুছে ফেলবে।',
    edit: 'সম্পাদনা করুন',
    standardAccount: 'স্ট্যান্ডার্ড অ্যাকাউন্ট',
    confirmEmailChange: 'ইমেল পরিবর্তন নিশ্চিত করুন',
    pleaseEnterPassword: 'অনুগ্রহ করে আপনার পাসওয়ার্ড দিন',
    cancel: 'বাতিল করুন',
    account: {
      title: 'অ্যাকাউন্ট',
      resetDescription: 'এটি আপনার প্রোফাইলের সমস্ত ডেটা এবং চ্যাটের ইতিহাস মুছে ফেলবে।',
      confirmReset: 'আপনি কি নিশ্চিত যে আপনি আপনার সমস্ত ডেটা রিসেট করতে চান? এটি আর ফেরানো যাবে না।',
      resetComplete: 'আপনার ডেটা রিসেট করা হয়েছে।'
    },
    language: {
      title: 'ভাষা',
      selectLabel: 'প্রদর্শনের ভাষা'
    },
    appearance: {
      title: 'চেহারা (Appearance)',
      lightTheme: 'লাইট',
      darkTheme: 'ডার্ক',
      systemTheme: 'সিস্টেম'
    },
    confirmDeleteAccount: 'আপনি কি নিশ্চিত যে আপনি আপনার অ্যাকাউন্ট মুছে ফেলতে চান? এই কাজটি আর ফেরানো যাবে না।',
    confirmAccountDeletion: 'অ্যাকাউন্ট মুছে ফেলা নিশ্চিত করুন',
    accountDeletionWarning: 'সতর্কতা: এই পদক্ষেপটি স্থায়ী এবং ফেরানো যাবে না। আপনার সমস্ত ডেটা স্থায়ীভাবে মুছে ফেলা হবে।',
    deletionReason: 'মুছে ফেলার কারণ (ঐচ্ছিক):',
    deletionReasonPlaceholder: 'কোন কারণে আপনি আপনার অ্যাকাউন্ট মুছে ফেলার সিদ্ধান্ত নিয়েছেন?',
    enterPasswordConfirm: 'নিশ্চিত করতে আপনার পাসওয়ার্ড লিখুন:',
    currentPasswordPlaceholder: 'আপনার বর্তমান পাসওয়ার্ড',
    deleting: 'মুছে ফেলা হচ্ছে...',
    permanentlyDeleteAccount: 'অ্যাকাউন্ট মুছুন',
    accountDeletedSuccess: 'আপনার অ্যাকাউন্ট সফলভাবে মুছে ফেলা হয়েছে।',
    incorrectPassword: 'ভুল পাসওয়ার্ড',
    accountDeletionFailed: 'অ্যাকাউন্ট মুছতে ব্যর্থ। অনুগ্রহ করে পরে আবার চেষ্টা করুন।',
    confirmChange: 'পরিবর্তন নিশ্চিত করুন',
    processing: 'প্রক্রিয়াকরণ হচ্ছে...',
    userDataReset: 'আপনার প্রোফাইলের ডেটা সফলভাবে রিসেট করা হয়েছে।',
    failedToResetUserData: 'আপনার প্রোফাইলের ডেটা রিসেট করতে ব্যর্থ। অনুগ্রহ করে পরে আবার চেষ্টা করুন।',
    changingEmailTo: 'আপনার ইমেল পরিবর্তন করা হচ্ছে',
    will: 'করবে',
    logOutSystem: 'আপনাকে সিস্টেম থেকে লগ আউট করবে',
    sendVerificationLink: 'আপনার নতুন ইমেলে একটি যাচাইকরণ লিঙ্ক পাঠাবে',
    requireVerification: 'আপনি আবার লগ ইন করার আগে যাচাইকরণের প্রয়োজন হবে',
    checkNewEmailVerification: 'অনুগ্রহ করে যাচাইকরণের নির্দেশাবলীর জন্য আপনার নতুন ইমেল চেক করুন।',
    unableToVerifyEmail: 'ইমেল যাচাই করতে অক্ষম। অনুগ্রহ করে আবার চেষ্টা করুন।',
    emailAlreadyInUse: 'ইমেলটি ইতিমধ্যেই ব্যবহার করা হচ্ছে',
    enterValidEmail: 'অনুগ্রহ করে একটি বৈধ ইমেল ঠিকানা লিখুন',
    failedToUpdateEmail: 'ইমেল আপডেট করতে ব্যর্থ। অনুগ্রহ করে আবার চেষ্টা করুন।',
    passwordResetInitiated: 'আপনার ইমেল ঠিকানায় একটি পাসওয়ার্ড রিসেট লিঙ্ক পাঠানো হয়েছে।',
    unableToLoadUser: 'ব্যবহারকারীর তথ্য লোড করতে অক্ষম। অনুগ্রহ করে আবার চেষ্টা করুন।',
    retry: 'পুনরায় চেষ্টা করুন',
    user: 'ব্যবহারকারী',
    loadingUserInfo: 'ব্যবহারকারীর তথ্য লোড হচ্ছে...',
    resetUserDataTitle: "ব্যবহারকারীর ডেটা রিসেট করুন",
    confirmResetUserData: "আপনি কি নিশ্চিত যে আপনি আপনার প্রোফাইলের সমস্ত ডেটা রিসেট করতে চান? এটি আপনার অ্যাকাউন্টের শংসাপত্রগুলি রেখে আপনার প্রোফাইলের সমস্ত তথ্য এবং চ্যাটের ইতিহাস মুছে ফেলবে।",
    reset: "রিসেট করুন",
    deleteAccountTitle: "অ্যাকাউন্ট মুছুন"
  },
  userProfile: {
    title: 'ব্যবহারকারীর প্রোফাইল',
    privacyInfo: "আরও তথ্য প্রদান করে, আপনি চ্যাটবট থেকে আরও নির্ভুল এবং অর্থবহ প্রতিক্রিয়া পাবেন। অনুগ্রহ করে আমাদের পর্যালোচনা করুন",
    privacyPolicyLink: 'গোপনীয়তা নীতি',
    tabComingSoon: 'এই ট্যাবটি তৈরি করা হচ্ছে এবং শীঘ্রই উপলব্ধ হবে।',
    saveSuccess: 'প্রোফাইল সফলভাবে সেভ করা হয়েছে',
    loadError: 'প্রোফাইলের ডেটা লোড করতে ত্রুটি',
    saveError: 'প্রোফাইল সেভ করতে ত্রুটি',
    confirmSaveTitle: "প্রোফাইল সেভ করুন",
    confirmSave: "আপনি কি নিশ্চিত যে আপনি এই পরিবর্তনগুলো সেভ করতে চান?",
    confirmCancel: 'আপনার কিছু অসংরক্ষিত পরিবর্তন আছে। আপনি কি নিশ্চিত যে আপনি বাতিল করতে চান?',
    confirmLeave: 'আপনি কি নিশ্চিত যে আপনি ছেড়ে যেতে চান? যেকোনো অসংরক্ষিত পরিবর্তন হারিয়ে যাবে।',
    confirmDiscardChanges: 'অসংরক্ষিত পরিবর্তন বাতিল করবেন?',
    uploadPhoto: 'ছবি আপলোড করুন',
    uploadFile: 'ফাইল আপলোড করুন',
    photoRequirements: 'ছবিটি অবশ্যই পরিষ্কার, সাম্প্রতিক এবং আপনার পুরো মুখ দেখাতে হবে',
    biometricRequirements: 'শুধুমাত্র অফিসিয়াল বায়োমেট্রিক ডেটা ফাইল গ্রহণ করা হয়',
    documentUpload: 'ডকুমেন্ট আপলোড',
    validationTitle: 'অনুগ্রহ করে নিম্নলিখিত ত্রুটিগুলি সংশোধন করুন:',
    profileIcon: 'প্রোফাইল আইকন',
    change: 'পরিবর্তন করুন',
    chooseProfileIcon: 'একটি প্রোফাইল আইকন চয়ন করুন',
    presetIcons: 'প্রিসেট আইকন',
    upload: 'আপলোড করুন',
    initials: 'আদ্যক্ষর (Initials)',
    clickToUpload: 'আপলোড করতে ক্লিক করুন',
    useThisImage: 'এই ছবিটি ব্যবহার করুন',
    useInitials: 'আদ্যক্ষর ব্যবহার করুন',
    tabs: {
      tab1: 'ব্যক্তিগত সনাক্তকরণ ডেটা',
      tab2: 'নাগরিক নিবন্ধন ও ডকুমেন্টেশন',
      tab3: 'ঠিকানা ও আবাসিক তথ্য',
      tab4: 'পরিচয় ও ভ্রমণ সংক্রান্ত নথিপত্র',
      tab5: 'স্বাস্থ্য ও চিকিৎসা রেকর্ড',
      tab6: 'কর্মসংস্থান ও অর্থনৈতিক ডেটা',
      tab7: 'শিক্ষা ও একাডেমিক রেকর্ড',
      tab8: 'আর্থিক ও কর সংক্রান্ত ডেটা',
      tab9: 'সামাজিক নিরাপত্তা ও কল্যাণ',
      tab10: 'ফৌজদারি ও আইনি রেকর্ড',
      tab11: 'পরিবহন ও গতিশীলতা',
      tab12: 'নাগরিক ও রাজনৈতিক অংশগ্রহণ'
    },
    actions: {
      cancel: 'বাতিল করুন',
      save: 'প্রোফাইল সেভ করুন',
      previous: 'পূর্ববর্তী',
      next: 'পরবর্তী',
      saving: 'সেভ করা হচ্ছে...'
    },
    fields: {
      fullName: 'পুরো নাম (ডাকনাম সহ)',
      dob: 'জন্ম তারিখ',
      gender: 'লিঙ্গ',
      nationality: 'জাতীয়তা',
      maritalStatus: 'বৈবাহিক অবস্থা',
      photograph: 'ছবি',
      biometric: 'আঙ্গুলের ছাপ / বায়োমেট্রিক ডেটা',
      birthCert: 'জন্ম নিবন্ধন',
      deathCert: 'মৃত্যু সনদ',
      marriageDivorce: 'বিবাহ / বিবাহবিচ্ছেদের রেকর্ড',
      adoption: 'দত্তক নেওয়ার রেকর্ড',
      citizenship: 'নাগরিকত্ব / ন্যাচারালাইজেশন ডকুমেন্ট',
      immigration: 'ইমিগ্রেশন এবং ভিসার ইতিহাস',
      currentAddress: 'বর্তমান আবাসিক ঠিকানা',
      previousAddresses: 'পূর্ববর্তী ঠিকানা',
      postalCode: 'পোস্টাল কোড',
      country: 'দেশ',
      residencyStatus: 'আবাসিক অবস্থা',
      homeOrRental: 'বাড়ির মালিকানা বা ভাড়ার বিবরণ',
      utilityBills: 'ঠিকানার সাথে লিঙ্ক করা ইউটিলিটি বিল',
      landRecords: 'জমি ও সম্পত্তির মালিকানার রেকর্ড',
      idCard: 'জাতীয় পরিচয়পত্র নম্বর',
      passport: 'পাসপোর্টের বিবরণ',
      driversLicense: "ড্রাইভিং লাইসেন্স",
      voterId: 'ভোটার আইডি',
      ssn: 'সামাজিক নিরাপত্তা / জাতীয় বীমা নম্বর',
      militaryRecords: 'সামরিক পরিষেবার রেকর্ড',
      medicalHistory: 'চিকিৎসার ইতিহাস এবং স্বাস্থ্যের অবস্থা',
      vaccinations: 'টিকাদান রেকর্ড',
      insuranceDetails: 'স্বাস্থ্য বীমার বিবরণ',
      disability: 'প্রতিবন্ধী অবস্থা',
      bloodType: 'রক্তের গ্রুপ',
      organDonor: 'অঙ্গ দাতার অবস্থা',
      prescriptions: 'প্রেসক্রিপশন এবং প্রাপ্ত চিকিৎসা',
      mentalHealth: 'মানসিক স্বাস্থ্যের ইতিহাস',
      eHistory: 'কর্মসংস্থানের ইতিহাস',
      currentEmployer: 'বর্তমান নিয়োগকর্তার বিবরণ',
      workPermits: 'ওয়ার্ক পারমিট এবং শ্রম চুক্তি',
      certifications: 'পেশাদার সার্টিফিকেশন এবং লাইসেন্স',
      unemployment: 'বেকারত্ব অবস্থা এবং প্রাপ্ত সুবিধা',
      tin: 'করদাতা সনাক্তকরণ নম্বর (TIN)',
      businessAffiliations: 'ব্যবসায়িক মালিকানা এবং কোম্পানির অধিভুক্তি',
      schools: 'স্কুল এবং বিশ্ববিদ্যালয় উপস্থিত ছিল',
      education: 'শিক্ষা',
      degrees: 'ডিপ্লোমা, ডিগ্রি এবং সার্টিফিকেশন',
      performance: 'একাডেমিক পারফরম্যান্স এবং টেস্ট স্কোর',
      academicRecords: "একাডেমিক রেকর্ড",
      scholarships: 'বৃত্তি এবং প্রাপ্ত আর্থিক সহায়তা',
      incomeTax: 'আয়কর রেকর্ড',
      bankAccounts: 'ব্যাংকিং এবং আর্থিক অ্যাকাউন্ট',
      propertyTax: 'সম্পত্তি কর প্রদান',
      businessTax: 'ব্যবসা কর ফাইলিং',
      pensionContrib: 'পেনশন অবদান এবং উত্তোলন',
      loanAid: 'ঋণ এবং সরকারি সহায়তা রেকর্ড',
      pensionStatus: 'পেনশনের অবস্থা এবং অবদান',
      childcare: 'শিশু যত্ন সহায়তা',
      foodAssistance: 'খাদ্য সহায়তা / কল্যাণমূলক কর্মসূচি',
      housingAssistance: 'আবাসন সহায়তা',
      policeRecords: 'পুলিশ রেকর্ড (অপরাধের ইতিহাস, গ্রেপ্তার, চার্জ)',
      courtCases: 'আদালতের মামলার ইতিহাস',
      finesPenalties: 'জরিমানা এবং শাস্তি',
      paroleProbation: 'প্যারোল বা প্রবেশনের অবস্থা',
      citizenshipRevocation: 'নাগরিকত্ব প্রত্যাহার (যদি প্রযোজ্য হয়)',
      vehicleReg: 'যানবাহন নিবন্ধনের বিবরণ',
      trafficViolations: 'ট্রাফিক লঙ্ঘন এবং জরিমানা',
      licenseHistory: 'ড্রাইভিং লাইসেন্সের ইতিহাস এবং অনুমোদন',
      publicTransportCard: 'পাবলিক ট্রান্সপোর্ট কার্ডের ব্যবহার',
      voterRegistration: 'ভোটার নিবন্ধনের বিবরণ',
      electionHistory: 'নির্বাচন অংশগ্রহণের ইতিহাস',
      partyMembership: 'রাজনৈতিক দলের সদস্যপদ',
      militaryStatus: 'সামরিক সেবা বা নিয়োগের অবস্থা',
      publicServiceRoles: 'জনসেবার ভূমিকা'
    },
    placeholders: {
      fullName: 'আপনার সম্পূর্ণ আইনি নাম লিখুন',
      nationality: 'আপনার জাতীয়তা লিখুন',
      searchCountries: 'দেশ খুঁজুন...',
      selectCountry: 'একটি দেশ নির্বাচন করুন',
      searchDisciplines: "বিভাগ/বিষয় খুঁজুন...",
      selectDiscipline: "একটি বিভাগ/বিষয় নির্বাচন করুন",
      searchDegrees: "ডিগ্রি খুঁজুন...",
      selectDegree: "একটি ডিগ্রি নির্বাচন করুন"
    },
    validation: {
      nameRequired: 'পুরো নাম আবশ্যক',
      dobRequired: 'জন্ম তারিখ আবশ্যক',
      dobFuture: 'জন্ম তারিখ ভবিষ্যতের হতে পারে না',
      requiredField: '{field} আবশ্যক',
      invalidFormat: '{field} এর জন্য অবৈধ বিন্যাস',
      futureDate: 'তারিখ ভবিষ্যতের হতে পারে না',
      invalidSelection: 'অনুগ্রহ করে একটি বৈধ নির্বাচন করুন',
      passwordLength: 'পাসওয়ার্ড কমপক্ষে ৮ অক্ষরের হতে হবে',
      matchError: 'ফিল্ড মিলছে না'
    },
    errors: {
      savingFailed: 'প্রোফাইল সেভ করতে ব্যর্থ',
      loadingFailed: 'প্রোফাইল ডেটা লোড করতে ব্যর্থ',
      invalidForm: 'অনুগ্রহ করে সব আবশ্যক ফিল্ড পূরণ করুন',
      invalidFileType: 'অবৈধ ফাইলের প্রকার',
      fileTooLarge: 'ফাইলটি অনেক বড়',
      countryLoadError: 'দেশ লোড করতে ত্রুটি',
      countryUpdateError: 'দেশ আপডেট করতে ত্রুটি'
    },
    notifications: {
      saveSuccess: 'প্রোফাইল সফলভাবে সেভ করা হয়েছে',
      saveFailed: 'প্রোফাইল সেভ করতে ব্যর্থ',
      loadSuccess: 'প্রোফাইল সফলভাবে লোড হয়েছে',
      loadFailed: 'প্রোফাইল লোড করতে ব্যর্থ',
      fieldRequired: 'এই ফিল্ডটি আবশ্যক',
      uploadSuccess: 'ফাইল সফলভাবে আপলোড হয়েছে',
      uploadFailed: 'ফাইল আপলোড করতে ব্যর্থ',
      formChanged: 'আপনার অসংরক্ষিত পরিবর্তন আছে',
      sessionExpired: 'আপনার সেশনের মেয়াদ শেষ হয়েছে, অনুগ্রহ করে আবার লগ ইন করুন',
      profileUpdated: 'আপনার প্রোফাইল আপডেট করা হয়েছে',
      profileIncomplete: 'আপনার প্রোফাইল অসম্পূর্ণ'
    },
    instructions: {
      fullNameHelp: 'আপনার অফিসিয়াল ডকুমেন্টে যেভাবে আছে সেভাবে আপনার সম্পূর্ণ আইনি নাম লিখুন',
      dobHelp: 'আপনার জন্ম তারিখ দিন MM/DD/YYYY ফর্ম্যাটে',
      uploadPhotoHelp: 'একটি সাম্প্রতিক ছবি আপলোড করুন। ফাইলটি অবশ্যই JPG, PNG, বা GIF এবং ২ মেগাবাইটের কম হতে হবে',
      passwordHelp: 'পাসওয়ার্ডে অন্তত ৮টি অক্ষর থাকতে হবে যার মধ্যে একটি বড় হাতের অক্ষর, একটি সংখ্যা এবং একটি বিশেষ অক্ষর থাকতে হবে',
      documentHelp: 'গৃহীত ফর্ম্যাট: PDF, JPG, PNG (সর্বোচ্চ ৫MB)',
      requiredFields: '* চিহ্নিত ফিল্ডগুলি আবশ্যক',
      selectFromList: 'অনুগ্রহ করে তালিকা থেকে একটি বিকল্প নির্বাচন করুন',
      nextTab: 'পরবর্তী বিভাগে যান',
      previousTab: 'আগের বিভাগে ফিরে যান',
      saveInstructions: 'আপনার তথ্য সংরক্ষণ করতে সেভ-এ ক্লিক করুন',
      cancelInstructions: 'পরিবর্তনগুলো বাতিল করতে বাতিল করুন-এ ক্লিক করুন'
    },
    completionStatus: {
      notStarted: 'শুরু হয়নি',
      inProgress: 'চলমান',
      complete: 'সম্পূর্ণ',
      percentComplete: '{percent}% সম্পূর্ণ',
      tabsCompleted: '{total} এর মধ্যে {completed} টি বিভাগ সম্পন্ন হয়েছে',
      tabComplete: 'ট্যাব সম্পন্ন হয়েছে!'
    },
    gender: {
      male: 'পুরুষ',
      female: 'নারী',
      other: 'অন্যান্য',
      preferNot: 'বলতে চাই না'
    },
    maritalStatus: {
      single: 'অবিবাহিত',
      married: 'বিবাহিত',
      divorced: 'বিবাহবিচ্ছেদ',
      widowed: 'বিধবা/বিপত্নীক',
      other: 'অন্যান্য'
    },
    residencyStatuses: {
      citizen: 'নাগরিক',
      permanentResident: 'স্থায়ী বাসিন্দা',
      temporaryResident: 'অস্থায়ী বাসিন্দা',
      other: 'অন্যান্য'
    },
    employmentStatuses: {
      employed: 'কর্মজীবী',
      selfEmployed: 'স্ব-নিযুক্ত',
      unemployed: 'বেকার',
      student: 'ছাত্র',
      retired: 'অবসরপ্রাপ্ত',
      homemaker: 'গৃহিণী',
      other: 'অন্যান্য'
    },
    educationLevels: {
      primary: 'প্রাথমিক শিক্ষা',
      secondary: 'মাধ্যমিক শিক্ষা',
      highSchool: 'উচ্চ বিদ্যালয়',
      vocational: 'বৃত্তিমূলক প্রশিক্ষণ',
      associate: 'অ্যাসোসিয়েট ডিগ্রি',
      bachelor: 'স্নাতক ডিগ্রি (Bachelor)',
      master: 'স্নাতকোত্তর ডিগ্রি (Master)',
      doctoral: 'ডক্টরাল ডিগ্রি',
      professional: 'পেশাদার ডিগ্রি',
      other: 'অন্যান্য'
    },
    proficiencyLevels: {
      native: 'মাতৃভাষা',
      fluent: 'সাবলীল',
      advanced: 'উন্নত',
      intermediate: 'মধ্যবর্তী',
      basic: 'মৌলিক'
    },
    bloodTypes: {
      aPositive: 'A+',
      aNegative: 'A-',
      bPositive: 'B+',
      bNegative: 'B-',
      abPositive: 'AB+',
      abNegative: 'AB-',
      oPositive: 'O+',
      oNegative: 'O-',
      unknown: 'অজানা'
    },
    languages: {
      english: 'ইংরেজি',
      french: 'ফরাসি',
      swahili: 'সোয়াহিলি',
      arabic: 'আরবি',
      spanish: 'স্প্যানিশ',
      portuguese: 'পর্তুগিজ',
      chinese: 'চীনা',
      japanese: 'জাপানি',
      german: 'জার্মান',
      russian: 'রাশিয়ান',
      hindi: 'হিন্দি',
      urdu: 'উর্দু',
      other: 'অন্যান্য'
    },
    yesNo: {
      yes: 'হ্যাঁ',
      no: 'না'
    },
    select: 'অনুগ্রহ করে নির্বাচন করুন',
    existingFile: 'বিদ্যমান ফাইল',
    noMatchingCountries: 'কোনো মানানসই দেশ পাওয়া যায়নি',
    noMatchingDisciplines: "কোনো মানানসই বিভাগ পাওয়া যায়নি",
    noMatchingDegrees: "কোনো মানানসই ডিগ্রি পাওয়া যায়নি",
    educationOptions: [
      "অ্যাকাউন্টিং", "অ্যারোস্পেস ইঞ্জিনিয়ারিং", "কৃষি বিজ্ঞান", "নৃবিজ্ঞান", "স্থাপত্য",
      "শিল্পকলা ইতিহাস", "কৃত্রিম বুদ্ধিমত্তা", "জ্যোতির্বিদ্যা", "অ্যাস্ট্রোফিজিক্স", "বায়োকেমিস্ট্রি",
      "বায়োমেডিক্যাল ইঞ্জিনিয়ারিং", "বায়োটেকনোলজি", "ব্যবসায় প্রশাসন", "কেমিক্যাল ইঞ্জিনিয়ারিং",
      "রসায়ন", "সিভিল ইঞ্জিনিয়ারিং", "যোগাযোগ", "কম্পিউটার ইঞ্জিনিয়ারিং", "কম্পিউটার সায়েন্স",
      "নির্মাণ ব্যবস্থাপনা", "ক্রিমিনাল জাস্টিস", "সাইবার নিরাপত্তা", "ডেটা সায়েন্স", "দাঁতের চিকিৎসা",
      "অর্থনীতি", "শিক্ষা", "ইলেকট্রিক্যাল ইঞ্জিনিয়ারিং", "প্রাথমিক শিক্ষা", "ইংরেজি সাহিত্য",
      "পরিবেশ প্রকৌশল", "পরিবেশ বিজ্ঞান", "ফ্যাশন ডিজাইন", "ফিল্ম স্টাডিজ",
      "অর্থসংস্থান (Finance)", "চারুকলা", "খাদ্য বিজ্ঞান", "ফরেনসিক সায়েন্স", "গেম ডিজাইন", "ভূগোল",
      "ভূতত্ত্ব", "গ্রাফিক ডিজাইন", "স্বাস্থ্য প্রশাসন", "ইতিহাস", "হসপিটালিটি ম্যানেজমেন্ট",
      "হিউম্যান রিসোর্সেস", "ইন্ডাস্ট্রিয়াল ডিজাইন", "ইন্ডাস্ট্রিয়াল ইঞ্জিনিয়ারিং", "ইনফরমেশন সিস্টেমস",
      "তথ্য প্রযুক্তি", "ইন্টেরিয়র ডিজাইন", "আন্তর্জাতিক ব্যবসা", "আন্তর্জাতিক সম্পর্ক",
      "সাংবাদিকতা", "আইন", "গ্রন্থাগার বিজ্ঞান", "ভাষাবিজ্ঞান", "ব্যবস্থাপনা", "মার্কেটিং",
      "মেটেরিয়ালস সায়েন্স", "গণিত", "মেকানিক্যাল ইঞ্জিনিয়ারিং", "মিডিয়া স্টাডিজ", "মেডিসিন",
      "আবহাওয়াবিদ্যা", "মাইক্রোবায়োলজি", "সংগীত", "ন্যানোটেকনোলজি", "নার্সিং", "পুষ্টিবিজ্ঞান",
      "অকুপেশনাল থেরাপি", "সমুদ্রবিজ্ঞান", "পেট্রোলিয়াম ইঞ্জিনিয়ারিং", "ফার্মেসি", "দর্শন",
      "ফটোগ্রাফি", "শারীরিক শিক্ষা", "ফিজিক্যাল থেরাপি", "পদার্থবিদ্যা", "রাষ্ট্রবিজ্ঞান",
      "মনোবিজ্ঞান", "পাবলিক অ্যাডমিনিস্ট্রেশন", "জনস্বাস্থ্য", "পাবলিক রিলেশনস", "রোবোটিক্স",
      "মাধ্যমিক শিক্ষা", "সমাজকর্ম", "সমাজবিজ্ঞান", "সফটওয়্যার ইঞ্জিনিয়ারিং", "বিশেষ শিক্ষা",
      "স্পোর্টস ম্যানেজমেন্ট", "পরিসংখ্যান", "সিস্টেমস ইঞ্জিনিয়ারিং", "থিয়েটার আর্টস", "পর্যটন",
      "নগর পরিকল্পনা", "ভেটেরিনারি মেডিসিন", "ওয়েব ডেভেলপমেন্ট", "বন্যপ্রাণী জীববিজ্ঞান", "প্রাণিবিদ্যা"
    ],
    degreeOptions: [
      "অ্যাসোসিয়েট ডিগ্রি", "ব্যাচেলর অফ আর্টস (BA)", "ব্যাচেলর অফ সায়েন্স (BS)", "ব্যাচেলর অফ ইঞ্জিনিয়ারিং (BEng)",
      "ব্যাচেলর অফ বিজনেস অ্যাডমিনিস্ট্রেশন (BBA)", "ব্যাচেলর অফ ফাইন আর্টস (BFA)", "ব্যাচেলর অফ এডুকেশন (BEd)",
      "ব্যাচেলর অফ মেডিসিন (MBBS)", "ব্যাচেলর অফ লজ (LLB)", "মাস্টার অফ আর্টস (MA)", "মাস্টার অফ সায়েন্স (MS)",
      "মাস্টার অফ বিজনেস অ্যাডমিনিস্ট্রেশন (MBA)", "মাস্টার অফ ইঞ্জিনিয়ারিং (MEng)", "মাস্টার অফ ফাইন আর্টস (MFA)",
      "মাস্টার অফ এডুকেশন (MEd)", "মাস্টার অফ লজ (LLM)", "মাস্টার অফ পাবলিক হেলথ (MPH)",
      "ডক্টর অফ ফিলোসফি (PhD)", "ডক্টর অফ মেডিসিন (MD)", "ডক্টর অফ এডুকেশন (EdD)",
      "ডক্টর অফ বিজনেস অ্যাডমিনিস্ট্রেশন (DBA)", "ডক্টর অফ জুরিসপ্রুডেন্স (JD)", "প্রফেশনাল ডিপ্লোমা",
      "টেকনিক্যাল ডিপ্লোমা", "ভোকেশনাল সার্টিফিকেট", "গ্র্যাজুয়েট সার্টিফিকেট", "পোস্ট-গ্র্যাজুয়েট ডিপ্লোমা", "পোস্ট-ডক্টরাল"
    ],
    aria: {
      tabList: 'প্রোফাইল ফর্মের বিভাগগুলি',
      nextButton: 'পরবর্তী বিভাগে যান',
      prevButton: 'আগের বিভাগে যান',
      closeButton: 'প্রোফাইল ফর্ম বন্ধ করুন',
      saveButton: 'প্রোফাইল ডেটা সেভ করুন',
      requiredField: 'আবশ্যক ফিল্ড',
      dropdownSelect: 'একটি বিকল্প নির্বাচন করুন'
    }
  },
  chatbot: {
    placeholder: 'আপনার জিজ্ঞাসা এখানে লিখুন...',
    sendButton: 'পাঠান',
    fileReceived: 'ফাইল সফলভাবে গৃহীত হয়েছে।',
    fileUploadError: 'ফাইল আপলোড করতে ত্রুটি।',
    processingError: 'আপনার অনুরোধ প্রক্রিয়া করতে ত্রুটি।',
    welcomeMessage: 'স্বাগতম! আমি আজ কিভাবে আপনাকে কেনিয়া সরকারের পরিষেবাগুলির সাথে সহায়তা করতে পারি?',
    attachFile: 'ফাইল সংযুক্ত করুন',
    fileTooLarge: 'ফাইলটি অনেক বড়। সর্বোচ্চ আকার হলো {maxSize}।',
    saveChat: 'চ্যাট সেভ করুন',
    chatSaved: 'চ্যাট সেভ করা হয়েছে',
    chatTitle: 'চ্যাটের শিরোনাম',
    chatTitlePlaceholder: 'এই চ্যাটের জন্য একটি শিরোনাম লিখুন',
    selectFolder: 'ফোল্ডার নির্বাচন করুন',
    newChat: 'নতুন চ্যাট',
    clearContext: 'প্রসঙ্গ পরিষ্কার করুন এবং একটি নতুন চ্যাট শুরু করুন',
    unsavedChanges: 'আপনার অসংরক্ষিত পরিবর্তন আছে। আপনি কি নিশ্চিত যে আপনি একটি নতুন চ্যাট শুরু করতে চান?',
    whatCanIHelp: "আমি আজ আপনাকে কীভাবে সাহায্য করতে পারি?",
    justChat: "শুধু চ্যাট করুন",
    queryContext: "কোয়েরি প্রসঙ্গ",
    contextAdded: 'আপনার কোয়েরিতে প্রসঙ্গ যোগ করা হয়েছে',
    contextRemoved: 'আপনার কোয়েরি থেকে প্রসঙ্গ সরানো হয়েছে',
    sessionUpdated: 'সেশন আপডেট করা হয়েছে',
    newChatStarted: 'একটি নতুন কথোপকথন শুরু হয়েছে',
    loadError: 'চ্যাটের ইতিহাস লোড করতে অক্ষম',
    responsePrefix: "আমি আপনার বার্তা পেয়েছি",
    withContext: "প্রসঙ্গের সাথে",
    conversationLoaded: "কথোপকথন সফলভাবে লোড হয়েছে!",
    saveConfirmTitle: "বিদ্যমান কথোপকথন সেভ করুন",
    saveConfirmMessage: "বিদ্যমান কথোপকথন সেভ করবেন?",
    loadConfirmTitle: "বিদ্যমান কথোপকথন লোড করুন",
    loadConfirmMessage: "আপনার অসংরক্ষিত পরিবর্তন আছে। আপনি কি সেগুলি বাতিল করতে চান এবং নির্বাচিত কথোপকথনটি লোড করতে চান, নাকি প্রথমে বর্তমান কথোপকথনটি সেভ করতে চান?",
    loadAndDiscard: "লোড করুন এবং বাতিল করুন",
    saveAndLoad: "সেভ করুন এবং লোড করুন",
    saveAndStartNew: "সেভ করুন এবং নতুন শুরু করুন",
    discardAndStartNew: "বাতিল করুন এবং নতুন শুরু করুন",
    newChatTitle: "নতুন চ্যাট শুরু করুন",
    exportChat: 'চ্যাট এক্সপোর্ট করুন',
    exportFilename: 'ফাইলের নাম',
    exportFilenamePlaceholder: 'ফাইলের নাম লিখুন',
    exportButton: 'এক্সপোর্ট',
    exportSuccess: 'চ্যাট সফলভাবে এক্সপোর্ট করা হয়েছে',
    exportError: 'চ্যাট এক্সপোর্ট করতে ব্যর্থ। অনুগ্রহ করে আবার চেষ্টা করুন।'
  },
  quickhelp: {
    // Labels (Short for UI)
    applyForID: "আইডি-এর জন্য আবেদন",
    payTaxes: "ট্যাক্স প্রদান",
    startBusiness: "ব্যবসা শুরু করুন",
    findHealthcare: "স্বাস্থ্যসেবা",
    educationServices: "শিক্ষা",
    transportLicenses: "পরিবহন",
    housingPrograms: "আবাসন",
    findJobs: "চাকরি খুঁজুন",
    justChat: "শুধু চ্যাট করুন",

    // User Prompts (Visible Text - First Person - what user sees in chat)
    justChatUserPrompt: "আমি সরকারি পরিষেবা নিয়ে চ্যাট করতে চাই",
    applyForIDUserPrompt: "কীভাবে একটি জাতীয় পরিচয়পত্রের জন্য আবেদন করতে হয় সে সম্পর্কে আমার তথ্য প্রয়োজন",
    payTaxesUserPrompt: "অনলাইনে আমার কর পরিশোধ করার প্রক্রিয়া কী?",
    startBusinessUserPrompt: "একটি নতুন ব্যবসা নিবন্ধন করার ধাপগুলোর মাধ্যমে আমাকে গাইড করুন",
    findHealthcareUserPrompt: "আমি পাবলিক স্বাস্থ্যসেবা সম্পর্কে কোথায় তথ্য পেতে পারি?",
    educationServicesUserPrompt: "আমার সন্তানদের জন্য কী কী শিক্ষা পরিষেবা উপলব্ধ আছে?",
    transportLicensesUserPrompt: "কীভাবে আমি আমার ড্রাইভিং লাইসেন্স নবায়ন করব?",
    housingProgramsUserPrompt: "কেনিয়ায় সাশ্রয়ী মূল্যের আবাসন কর্মসূচি সম্পর্কে আমাকে বলুন",
    findJobsUserPrompt: "বর্তমানে সরকারি চাকরির কী সুযোগ রয়েছে?",

    // System Prompts (Hidden from User - detailed prompts sent to LLM)
    applyForIDPrompt: "একজন সহায়ক কেনিয়ান নাগরিক নিবন্ধন বিশেষজ্ঞ হিসেবে কাজ করুন। একটি জাতীয় পরিচয়পত্র (Maisha Namba) পাওয়ার বাহারিয়ে যাওয়া কার্ড প্রতিস্থাপনের পদক্ষেপগুলো ব্যাখ্যা করুন। গুরুত্বপূর্ণ: প্রয়োজনীয় নথিপত্রের একটি স্পষ্ট তালিকা প্রদান করুন (যেমন: জন্ম সনদ, বাবা-মায়ের আইডির অনুলিপি) এবং ব্যবহারকারীকে তাদের নিকটস্থ হুদুমা (Huduma) কেন্দ্র বা রেজিস্ট্রার অফ পার্সন্স অফিসে যাওয়ার পরামর্শ দিন। নিয়ম: সর্বদা অ্যাপ্লিকেশনটিকে 'জিনি এআই (Genie AI)' হিসেবে উল্লেখ করবেন।",

    payTaxesPrompt: "একজন KRA (কেনিয়া রেভিনিউ অথরিটি) গাইড হিসেবে কাজ করুন। রিটার্ন জমা দেওয়া, KRA পিন-এর জন্য আবেদন করা বা iTax পোর্টালে পাসওয়ার্ড রিসেট করার প্রক্রিয়াটি ব্যাখ্যা করুন। গুরুত্বপূর্ণ: বার্ষিক রিটার্ন জমা দেওয়ার জন্য ব্যবহারকারীকে ৩০শে জুনের সময়সীমার কথা মনে করিয়ে দিন এবং তাদের কোনো আয় না থাকলে কীভাবে শূন্য (Nil) রিটার্ন জমা দিতে হয সে বিষয়ে গাইড করুন। নিয়ম: সর্বদা অ্যাপ্লিকেশনটিকে 'জিনি এআই (Genie AI)' হিসেবে উল্লেখ করবেন।",

    startBusinessPrompt: "ই-সিটিজেন (eCitizen) পরিষেবাগুলোর জন্য একজন ব্যবসায়িক পরামর্শদাতা হিসেবে কাজ করুন। কেনিয়ায় ব্যবসার নাম সংরক্ষণ এবং কোম্পানি নিবন্ধনের মাধ্যমে ব্যবহারকারীকে গাইড করুন। গুরুত্বপূর্ণ: নাম অনুসন্ধান এবং নিবন্ধনের জন্য বর্তমান খরচগুলো ব্যাখ্যা করুন এবং আবেদনটি সম্পূর্ণ করতে ব্যবহারকারীকে অফিসিয়াল ই-সিটিজেন পোর্টালে নির্দেশ করুন। নিয়ম: সর্বদা অ্যাপ্লিকেশনটিকে 'জিনি এআই (Genie AI)' হিসেবে উল্লেখ করবেন।",

    findHealthcarePrompt: "একজন স্বাস্থ্য পরিষেবা নেভিগেটর হিসেবে কাজ করুন। NHIF থেকে SHIF (সোশ্যাল হেলথ ইন্স্যুরেন্স ফান্ড)-এ রূপান্তর এবং কীভাবে নিবন্ধন করতে হয় সে সম্পর্কে তথ্য প্রদান করুন। গুরুত্বপূর্ণ: নিবন্ধনের জন্য অফিসিয়াল USSD কোডগুলো (যেমন *263#) বা ওয়েবসাইটের লিঙ্কগুলো শেয়ার করুন এবং জনস্বাস্থ্য কভারের সুবিধাগুলো ব্যাখ্যা করুন। নিয়ম: সর্বদা অ্যাপ্লিকেশনটিকে 'জিনি এআই (Genie AI)' হিসেবে উল্লেখ করবেন।",

    educationServicesPrompt: "একজন শিক্ষা পরামর্শদাতা হিসেবে কাজ করুন। CBC পাঠ্যক্রম, NEMIS নিবন্ধন, বা KUCCPS-এর মাধ্যমে বিশ্ববিদ্যালয়ে নিয়োগ নিয়ে আলোচনা করুন। গুরুত্বপূর্ণ: পরীক্ষার ফলাফল প্রকাশিত হলে পিতামাতারা কীভাবে SMS বা KNEC পোর্টালের মাধ্যমে জাতীয় পরীক্ষার ফলাফল চেক করতে পারেন তা ব্যাখ্যা করুন। নিয়ম: সর্বদা অ্যাপ্লিকেশনটিকে 'জিনি এআই (Genie AI)' হিসেবে উল্লেখ করবেন।",

    transportLicensesPrompt: "একজন NTSA সার্ভিস গাইড হিসেবে কাজ করুন। ড্রাইভিং লাইসেন্স নবায়ন, যানবাহন পরিদর্শন, বা TIMS অ্যাকাউন্ট পরিচালনার প্রক্রিয়াটি ব্যাখ্যা করুন। গুরুত্বপূর্ণ: ব্যবহারকারীকে তাদের স্মার্ট DL-এর জন্য আবেদন করতে বা গাড়ির পরিদর্শন বুক করতে eCitizen NTSA পোর্টালে কীভাবে লগইন করতে হয় সে সম্পর্কে গাইড করুন। নিয়ম: সর্বদা অ্যাপ্লিকেশনটিকে 'জিনি এআই (Genie AI)' হিসেবে উল্লেখ করবেন।",

    housingProgramsPrompt: "একজন আবাসন কর্মসূচি উপদেষ্টা হিসেবে কাজ করুন। অ্যাফোর্ডেবল হাউজিং প্রোগ্রাম (বোমা ইয়াঙ্গু/Boma Yangu) নিবন্ধন এবং স্বেচ্ছায় অবদান রাখার প্রক্রিয়াটি ব্যাখ্যা করুন। গুরুত্বপূর্ণ: প্রজেক্টগুলো দেখার জন্য ব্যবহারকারীকে বোমা ইয়াঙ্গু পোর্টালে গাইড করুন এবং বরাদ্দের যোগ্যতার মানদণ্ড ব্যাখ্যা করুন। নিয়ম: সর্বদা অ্যাপ্লিকেশনটিকে 'জিনি এআই (Genie AI)' হিসেবে উল্লেখ করবেন।",

    findJobsPrompt: "পাবলিক সার্ভিসের জন্য একজন ক্যারিয়ার কোচ হিসেবে কাজ করুন। পাবলিক সার্ভিস কমিশন (PSC) পোর্টালের মাধ্যমে একটি প্রোফাইল তৈরি করা এবং শূন্যপদের জন্য আবেদন করার বিষয়ে ব্যবহারকারীকে গাইড করুন। গুরুত্বপূর্ণ: ব্যবহারকারীকে তাদের একাডেমিক সার্টিফিকেট প্রস্তুত রাখতে এবং MyGov বিজ্ঞাপনের জন্য নিয়মিত PSC ওয়েবসাইট বা স্থানীয় সংবাদপত্র চেক করার পরামর্শ দিন। নিয়ম: সর্বদা অ্যাপ্লিকেশনটিকে 'জিনি এআই (Genie AI)' হিসেবে উল্লেখ করবেন।",

    justChatPrompt: "একজন বন্ধুত্বপূর্ণ স্থানীয় সঙ্গীহিসেবে কাজ করুন। কেনিয়ান সংস্কৃতি এবং দৈনন্দিন জীবন সম্পর্কে বিনয়ী, সহায়ক এবং জ্ঞানী হন। গুরুত্বপূর্ণ: ব্যবহারকারীকে মনে করিয়ে দিন যে আপনি যেকোনো বিষয়ে চ্যাট করতে পারলেও, আপনার মূল শক্তি হলো কেনিয়ান সরকারি পরিষেবা যেমন **আইডি**, **ট্যাক্স**, এবং **ব্যবসা নিবন্ধন** নেভিগেট করতে তাদের সাহায্য করা। নিয়ম: সর্বদা অ্যাপ্লিকেশনটিকে 'জিনি এআই (Genie AI)' হিসেবে উল্লেখ করবেন।"
  },
  common: {
    cancel: 'বাতিল করুন',
    create: 'তৈরি করুন',
    save: 'সেভ করুন',
    move: 'সরান',
    delete: 'মুছুন',
    ok: 'ঠিক আছে',
    ingest: 'ইনজেস্ট করুন',
    retract: 'প্রত্যাহার করুন',
    loading: 'লোড হচ্ছে...',
    refresh: 'রিফ্রেশ'
  },
  feedback: {
    title: 'প্রতিক্রিয়া',
    button: 'প্রতিক্রিয়া',
    positive: 'ইতিবাচক প্রতিক্রিয়া',
    negative: 'নেতিবাচক প্রতিক্রিয়া',
    promptText: 'এই প্রতিক্রিয়া কি সহায়ক ছিল?',
    placeholder: 'অতিরিক্ত মন্তব্য...',
    submit: 'প্রতিক্রিয়া জমা দিন',
    close: 'বাতিল করুন',
    thankYouMessage: 'আপনার প্রতিক্রিয়ার জন্য ধন্যবাদ!',
    submitting: 'জমা দেওয়া হচ্ছে...',
    error: 'কিছু ভুল হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।',
    success: 'আপনার প্রতিক্রিয়ার জন্য ধন্যবাদ!',
  },
  responseRating: {
    title: 'আমাদের উন্নতি করতে সাহায্য করুন',
    note: 'আপনার প্রতিক্রিয়া চ্যাটবটকে আরও ভালোভাবে টিউন করতে এবং সময়ের সাথে প্রতিক্রিয়া উন্নত করতে ব্যবহৃত হবে।',
    chatbotResponse: 'চ্যাটবট প্রতিক্রিয়া:',
    ratingLabels: {
      1: 'অকেজো',
      2: 'সামান্য সহায়ক',
      3: 'মাঝারিভাবে সহায়ক',
      4: 'খুব সহায়ক',
      5: 'জীবন পরিবর্তনকারী'
    },
    additionalComments: 'অতিরিক্ত মন্তব্য...',
    submit: 'জমা দিন',
    cancel: 'বাতিল করুন'
  },
  upload: {
    alt: 'আপলোড করুন'
  },
  details: {
    loading: 'ফাইলের বিবরণ লোড হচ্ছে...',
    title: 'ফাইলের বিবরণ',
    close: 'বন্ধ করুন',
    fileName: 'ফাইলের নাম',
    author: 'লেখক',
    labels: 'লেবেল',
    selectAll: 'সব নির্বাচন করুন',
    loadingLabels: 'লেবেল লোড হচ্ছে...',
    status: 'স্ট্যাটাস',
    fileId: 'ফাইল আইডি',
    fileType: 'ফাইলের ধরন',
    viewFile: 'ফাইল দেখুন',
    visitLink: 'বাহ্যিক লিঙ্কে যান',
    openFile: 'নতুন ট্যাবে ফাইল খুলুন',
    fileSize: 'ফাইলের আকার',
    uploadDate: 'আপলোডের তারিখ',
    hash: 'SHA256 হ্যাশ',
    tabs: {
      details: "বিবরণ",
      ingestionLog: "ইনজেশন লগ"
    },
    log: {
      killActions: "কিল অ্যাকশন (Kill Actions):",
      killDocument: "এই ডকুমেন্টটি কিল করুন",
      killProcess: "ইনজেশন প্রক্রিয়া কিল করুন",
      timestamp: "টাইমস্ট্যাম্প",
      level: "স্তর",
      stage: "পর্যায়",
      message: "বার্তা",
      loadingLogs: "লগ লোড হচ্ছে...",
      noLogs: "কোনো লগ পাওয়া যায়নি।"
    },
    buttons: {
      saveMetadata: 'মেটাডেটা সেভ করুন',
      retract: 'প্রত্যাহার করুন',
      ingest: 'ইনজেস্ট করুন'
    },
    notifications: {
      loadError: 'ফাইলের বিবরণ লোড করতে ব্যর্থ।',
      validationError: 'ফাইলের নাম এবং লেখক আবশ্যক।',
      saveSuccess: 'মেটাডেটা সফলভাবে আপডেট করা হয়েছে।',
      saveError: 'মেটাডেটা সেভ করতে ব্যর্থ।',
      tokenError: 'ব্যবহারকারীর ডেটাতে প্রমাণীকরণ টোকেন পাওয়া যায়নি।',
      viewError: 'দেখার জন্য ফাইল লোড করা যায়নি।',
      ingestSuccess: 'ফাইল সফলভাবে ইনজেশনের জন্য সারিবদ্ধ করা হয়েছে।',
      ingestError: 'ইনজেশন প্রক্রিয়া শুরু করতে ব্যর্থ।',
      retractSuccess: 'ফাইল প্রত্যাহার করা হয়েছে।',
      retractError: 'ফাইল প্রত্যাহার করতে ব্যর্থ।',
      deleteSuccess: 'ফাইল সফলভাবে মুছে ফেলা হয়েছে।',
      deleteError: 'ফাইল মুছতে ব্যর্থ।',
      ingestLabelRequired: "ইনজেস্ট করার আগে অনুগ্রহ করে কমপক্ষে একটি লেবেল নির্বাচন করুন।",
      ingestSaving: "ইনজেশনের আগে মেটাডেটা সেভ করা হচ্ছে...",
      ingestSaveFailed: "মেটাডেটা সেভ করতে ব্যর্থ। ইনজেশন বাতিল করা হয়েছে।",
      logError: "ইনজেশন লগ আনতে ব্যর্থ।",
      killDocSent: "এই ডকুমেন্টের জন্য কিল করার অনুরোধ পাঠানো হয়েছে।",
      killProcSent: "ইনজেশন প্রক্রিয়ার জন্য কিল করার অনুরোধ পাঠানো হয়েছে।"
    },
    confirm: {
      ingest: 'আপনি কি নিশ্চিত যে আপনি এই ফাইলটি ইনজেস্ট করতে চান? এটি ডেটা প্রসেসিং পাইপলাইন শুরু করবে।',
      retract: 'আপনি কি নিশ্চিত যে আপনি এই ফাইলটি প্রত্যাহার করতে চান?',
      delete: 'আপনি কি নিশ্চিত যে আপনি স্থায়ীভাবে এই ফাইলটি মুছতে চান? এই কাজটি আর ফেরানো যাবে না।',
      ingestTitle: "ইনজেশন নিশ্চিত করুন",
      retractTitle: "প্রত্যাহার নিশ্চিত করুন",
      deleteTitle: "মুছে ফেলা নিশ্চিত করুন",
      killDocTitle: "ডকুমেন্ট ইনজেশন কিল করুন",
      killDoc: "আপনি কি নিশ্চিত যে আপনি এই ডকুমেন্টের জন্য ইনজেশন টাস্ক কিল করতে চান? প্রক্রিয়াটি একটি সুন্দর রোলব্যাকের চেষ্টা করবে।",
      killProcTitle: "সম্পূর্ণ ইনজেশন প্রক্রিয়া কিল করুন",
      killProc: "সতর্কতা: এটি সম্পূর্ণ ব্যাকএন্ড ইনজেশন পরিষেবা কিল করবে, যা বর্তমানে প্রক্রিয়াকরণরত সমস্ত ফাইলকে প্রভাবিত করবে। আপনি কি সম্পূর্ণ নিশ্চিত?"
    }
  },
  uploadDialog: {
    title: 'ফাইল আপলোড করুন',
    dropzone: 'এখানে ফাইল টেনে আনুন, অথবা নির্বাচন করতে ক্লিক করুন',
    allowedTypesLabel: 'অনুমোদিত প্রকারগুলি:',
    buttonUpload: '{count} টি ফাইল আপলোড করুন',
    remove: 'সরান',
    uploading: 'আপলোড করা হচ্ছে...',
    notifications: {
      dropError: 'শুধুমাত্র ফাইল ড্রপ করা যেতে পারে। অনুগ্রহ করে চেক করুন আপনি আপনার কম্পিউটার থেকে একটি বৈধ ফাইল টেনে আনছেন কিনা।',
      typeNotAllowed: 'ফাইলের প্রকার "{extension}" অনুমোদিত নয়।',
      shortcutUnsupported: 'শর্টকাট ফাইল (.url) সমর্থিত নয়। অনুগ্রহ করে আসল ফাইলটি টেনে আনুন।',
      duplicate: 'ফাইল "{fileName}" ইতিমধ্যে যোগ করা হয়েছে।',
      uploadSuccess: 'সফলভাবে আপলোড হয়েছে {fileName}',
      uploadFailed: '{fileName} আপলোড করতে ব্যর্থ।'
    }
  }
}